import React from 'react';
import { connect } from 'react-redux';
import {
  resourceActions,
  permissionActions,
  manifestActions,
  inventoryActions,
  assignmentStatsActions,
} from '../_actions';
import { authHeader, config } from '../_helpers';
import CircularProgressbar from 'react-circular-progressbar';
import '../assets/styles/your-crew.css';
import DatePicker from 'react-datepicker';
import ReactModal from 'react-modal';
import { toast } from 'react-toastify';
import moment from 'moment';
import Accordian from '_components/Accordian';
import { Link } from 'react-router-dom';
import EmployeeList from 'Employees/EmployeeList';
import AllManifest from '_components/AllManifest';
import Modal from '_components/utils/Modal/Modal';
import RadioButton from 'Docs/Components/RadioButton';
import FireHistoryEmployeeAssignDragAndDrop from 'Resources/FireHistoryEmployeeAssignDragAndDrop';
import { formatDate, getCurrentDatePST } from '_helpers/helpers';
import { preventNegativeValueInDocs } from '_helpers/helpers';
import PropTypes from 'prop-types';
import CustomToolTip from '_components/CustomToolTip/CustomToolTip';
import { manifestService } from '../_services';
import EmailManifestModal from '_components/EmailManifestModal';

const currentDate = getCurrentDatePST();

const assignmentStatuses = [
  { label: 'Assignment Status', value: '' },
  { label: 'Available', value: 'Available' },
  { label: 'Unavailable', value: 'Unavailable' },
];
const RESOURCE_ORDER_FILE_TYPE = {
  CREATE_FORM: 1,
  UPLOADED_FORM: 2,
};

const unDefined = 'undefined';

const FIRE_HISTORY_TYPE_SLUG = {
  WITH_MANIFEST: 'with_manifest',
  AUTO_ASSIGN_MANIFEST: 'auto_assign',
  MANUAL_ASSIGN_MANIFEST: 'manual_assign',
};
class YourCrewDetails extends React.Component {
  constructor(props) {
    super(props);
    this.sortYourCrewRef = React.createRef();
    this.manifestTableRef = React.createRef();
    this.state = {
      typeSlug: FIRE_HISTORY_TYPE_SLUG?.AUTO_ASSIGN_MANIFEST,
      editMode: false,
      resource_name: '',
      id: '',
      resultData: {},
      vehiclesOption: [],
      manifest: [],
      employeesOption: [],
      permList: [],
      flag: true,
      assignmentStatusOptions: ['Available', 'Unavailable', 'Committed'],
      currentAssignmentStatus: 'Available', //variable to save current assignment status
      resourceAvailabilityStatus: 'available', // API resource availability status
      unavailabilityDetails: null, // Unavailability details from API
      tempAssignmentStatus: '', //variable to save assignment status when the user change in the popup , for displaying the form fields based on the selection
      currentProjectDetails: [], //array to store all details about current project
      unavailable_reason_id: '',
      unavailable_reasons: [],
      onDate: moment(currentDate),
      offDate: '',
      unavailable_start_date: '',
      unavailable_end_date: '',
      preventAssignmentPopupClick: false,
      currentAssignmentDetails: {
        name: '',
        date_off: '',
        date_on: '',
        assignment_type_id: '',
        assignment_type: '',
        shifts: '',
        notes: '',
        id: 0,
        manifest_id: 0,
      },
      errorMessage: '',
      deleteHistoryOpen: false,
      historyId: '',
      assigmentCategoryOptions: [],
      assigmentStatusHistory: { data: [] },
      incidentProjects: [],
      projectId: null,
      projectName: '',
      projectNote: '',
      projectShift: '',
      tempAssignmentType: '',
      assignmentHistoryId: '',
      inventoryList: [],
      inventoryPage: 1,
      inventoryLastPage: 0,
      inventoryPerPage: 1,
      location: '',
      complexity: '',
      fuel_type: '',
      fire_size: '',
      hotline_shifts: '',
      isCrewCommitted: false,
      confirmEditAssignment: false,
      displayEditAssignmentConfirmPopup: false,
      latestAssignmentHistory: null,
      manifestStatus: 'closedout',
      manifestCloseOutDateOff: null,
      manifestCloseOutHotlineShifts: '',
      manifestCloseOutNotes: '',
      isManifestCloseOut: false,
      deletedManifestHistory: { data: [] },
      deletedHistoryPage: 1,
      deletedHistoryLastPage: 0,
      deletedHistoryPerPage: 15,
      deletedHistoryLoading: false,
      ManifestListV1: [],
      manifestPagination: null,
      emailManifestModalOpen: false, // Flag for email manifest modal
      commitManifestLoading: false, // Loading state for commit manifest
      dispatchMailList: [],
      mailList: [],
      mailSearchKeyword: '',
      hideSearch: 'hide',
      validManifestMail: false,
      manifestEmail: '',
      searchList: [],
    };
    this.keyUpFn = this.keyUpFn.bind(this);
    this.onImageError = this.onImageError.bind(this);
    this.deleteHistoryCloseModal = this.deleteHistoryCloseModal.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.editResourceHistory = this.editResourceHistory.bind(this);
    this.selectProject = this.selectProject.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.inventoryPagination = this.inventoryPagination.bind(this);
    this.getInventoryList = this.getInventoryList.bind(this);
    this.getUnavailableReasons = this.getUnavailableReasons.bind(this);
    this.renderTotalShifts = this.renderTotalShifts.bind(this);
    this.handleOnWheel = this.handleOnWheel.bind(this);
    this.editManifestStatus = this.editManifestStatus.bind(this);
    this.emailChangeFn = this.emailChangeFn.bind(this);
    this.addManifestEmail = this.addManifestEmail.bind(this);
    this.removeList = this.removeList.bind(this);
    this.removeDispatchList = this.removeDispatchList.bind(this);
    this.isValidEmail = this.isValidEmail.bind(this);
  }

  selectProject(e) {
    let id = e.target.value;
    this.setState({
      projectId: id || null,
    });
  }

  handleSelect(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleOnWheel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.blur();
  };

  renderTotalShifts = (onDate, offDate) => {
    if (offDate && onDate) {
      const diffInDays =
        offDate.startOf('day').diff(onDate.startOf('day'), 'days') + 1;

      this.setState({ projectShift: diffInDays });
      return;
    }
    this.setState({ projectShift: '' });
  };

  formatResourceAvailabilityStatus = (status) => {
    if (!status) return '-';
    const statusStr = String(status).toLowerCase();
    switch (statusStr) {
      case 'available':
      case '1':
        return 'Available';
      case 'unavailable':
      case '2':
        return 'Unavailable';
      case 'committed':
      case '3':
        return 'Committed';
      default:
        return status;
    }
  };

  getStatusClass = (status) => {
    switch (status) {
      case 'closedout':
        return 'red';
      case 'pending':
        return 'pending';
      case 'inuse':
      case 'available':
      default:
        return 'gray';
    }
  };

  getStatusLabel = (status) => {
    switch (status) {
      case 'closedout':
        return 'Closed Out';
      case 'inuse':
        return 'In Use';
      case 'pending':
        return 'Pending';
      default:
        return 'Available';
    }
  };

  /**
   * Get human-readable manifest status label
   * @param {string} manifestStatus - Manifest status
   * @returns {string} Manifest status label
   */
  getManifestStatusLabel = (manifestStatus) => {
    if (!manifestStatus) {
      return '-';
    }
    switch (manifestStatus) {
      case 'inuse':
        return 'In Use';
      case 'closedout':
        return 'Closed Out';
      case 'pending':
        return 'Manifest Pending';
      default:
        return manifestStatus;
    }
  };

  handleViewResourceOrderForm(manifest) {
    try {
      const resourceOrderFormType =
        manifest.resourceOrderFormType || manifest.resource_order_form_type;
      const resourceOrderForm =
        manifest.resourceOrderForm || manifest.resource_order_form;

      switch (resourceOrderFormType) {
        case RESOURCE_ORDER_FILE_TYPE?.UPLOADED_FORM:
          if (resourceOrderForm) {
            window.open(resourceOrderForm, '_blank').focus();
          } else {
            toast.error('Resource order form file not found');
          }
          break;
        case RESOURCE_ORDER_FILE_TYPE?.CREATE_FORM:
          this.printResourceOrderForm(manifest);
          break;
        default:
          // Try to handle as UPLOADED_FORM if resourceOrderForm exists
          if (resourceOrderForm) {
            window.open(resourceOrderForm, '_blank').focus();
          } else {
            console.warn(
              'Unknown resource order form type:',
              resourceOrderFormType,
            );
            toast.error('Unable to view resource order form');
          }
          break;
      }
    } catch (error) {
      console.error('Error viewing resource order form:', error);
      toast.error('Error viewing resource order form');
    }
  }

  printResourceOrderForm(manifest) {
    try {
      let data = new FormData();
      const manifestId =
        manifest.manifestId || manifest.manifest_id || manifest.mid;
      data.append('manifest_id', manifestId);

      manifestService
        ?.viewCreatedResourceOrderForm(data)
        .then((response) => {
          this?.redirectToPdf(response);
        })
        .catch((error) => {
          console.error('Error fetching resource order form:', error);
          toast.error('Error loading resource order form');
        });
    } catch (error) {
      console.error('Error in printResourceOrderForm:', error);
      toast.error('Error generating resource order form');
    }
  }

  redirectToPdf = (data) => {
    if (data?.success) {
      const pdfLink = data.data;
      var link = document.createElement('a');
      if (
        window.navigator.userAgent.match(/iPad/i) ||
        window.navigator.userAgent.match(/iPhone/i)
      ) {
        link.href = pdfLink;
      } else {
        link.href = pdfLink;
        link.target = '_blank';
      }
      document.body.appendChild(link);
      link.click();
      setTimeout(function () {
        document.body.removeChild(link);
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(pdfLink);
      }, 100);
    }
  };

  fetchData() {
    this.setState({ flag: true });
    this.getUnavailableReasons();
    this.props.dispatch(permissionActions.getPermission());
    this.props.dispatch(assignmentStatsActions.getAssignemntStatusTypes());
    this.props.dispatch(resourceActions.getProjects());

    var self = this;
    fetch(config.apiUrl + '/api/user', {
      headers: authHeader(),
      method: 'GET',
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        self.setState(
          {
            resource_name: data.data.crew_name,
            id: data.data.crew_identifier_id,
            flag: true,
          },
          function () {
            this.props.dispatch(
              assignmentStatsActions.getAssignemntStatus(self.state.id),
            );
            this.props.dispatch(
              assignmentStatsActions.getAssignemntHistory(self.state.id, 1),
            );
            self.fetchDeletedManifestHistory(1);
            self.getManifestList();
            let data = '?id=' + self.state.id;
            self.props.dispatch(inventoryActions.getInventoryStats(data));
            this.props
              .dispatch(
                inventoryActions.getPaginatedList({
                  id: this.state.id,
                  page: 1,
                }),
              )
              .then((res) => {
                this.setState({
                  inventoryList: res.data || [],
                  inventoryPage: res.current_page,
                  inventoryLastPage: res.last_page,
                  inventoryPerPage: res.per_page,
                });
              });

            // Fetch resource availability status after state is set
            setTimeout(() => {
              self.fetchResourceDetails();
            }, 100);
          },
        );

        self.props.dispatch(
          resourceActions.getResourceVehicles(data.data.crew_identifier_id),
        );

        self.getEmployeeList(data);

        let data2 = new FormData();
        data2.append('resource_id', data.data.crew_identifier_id);
      });

    this.props.dispatch(assignmentStatsActions.getAssignmentComplexity());
    this.props.dispatch(assignmentStatsActions.getAssignmentFireSize());
    this.props.dispatch(assignmentStatsActions.getAssignmentFuelType());
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchResourceDetails = () => {
    // Ensure we have a valid resource identifier
    if (!this.state.id) {
      console.error('Resource identifier is not available');
      return;
    }

    manifestService
      .getResourceDetails(this.state.id)
      .then((response) => {
        if (response.status === 'success') {
          const resourceData = response.data;

          // Use the API's resource_availability_status directly
          let currentAssignmentStatus = 'Available'; // Default status

          // Map the API status to display status
          switch (resourceData.resource_availability_status) {
            case 'available':
              currentAssignmentStatus = 'Available';
              break;
            case 'unavailable':
              currentAssignmentStatus = 'Unavailable';
              break;
            case 'committed':
              currentAssignmentStatus = 'Committed';
              break;
            default:
              currentAssignmentStatus = 'Available';
          }

          this.setState(
            {
              currentAssignmentStatus,
              resourceAvailabilityStatus:
                resourceData.resource_availability_status,
              unavailabilityDetails: resourceData.unavailability_details,
            },
            () => {},
          );
        } else {
        }
      })
      .catch((error) => {
        console.error('Error fetching resource details:', error);
        // Fallback to default status if API fails
        this.setState({
          currentAssignmentStatus: 'Available',
          resourceAvailabilityStatus: 'available',
          unavailabilityDetails: null,
        });
      });
  };

  fetchDeletedManifestHistory = (page = 1) => {
    this.setState({ deletedHistoryLoading: true });

    manifestService
      .getDeletedManifestHistory(
        this.state.id,
        this.state.deletedHistoryPerPage,
        page,
      )
      .then((response) => {
        if (response.status === 'success') {
          this.setState({
            deletedManifestHistory: response.data.deletedAssignmentHistory,
            deletedHistoryPage:
              response.data.deletedAssignmentHistory.current_page,
            deletedHistoryLastPage:
              response.data.deletedAssignmentHistory.last_page,
            deletedHistoryLoading: false,
          });
        } else {
          this.setState({ deletedHistoryLoading: false });
        }
      })
      .catch((error) => {
        console.error('Error fetching deleted manifest history:', error);
        this.setState({ deletedHistoryLoading: false });
      });
  };

  getDeletedHistoryPaginationHtml = () => {
    let paginationHtml = [];

    if (this.state.deletedManifestHistory?.data?.length > 0) {
      let pages = [];
      let currentPage = this.state.deletedHistoryPage;
      let startingIndex = currentPage - 2 > 0 ? currentPage - 2 : 1;
      let lastPageIndex =
        currentPage + 2 < this.state.deletedHistoryLastPage
          ? currentPage + 2
          : this.state.deletedHistoryLastPage;
      let nextPage =
        currentPage + 1 > this.state.deletedHistoryLastPage
          ? this.state.deletedHistoryLastPage
          : currentPage + 1;
      let prevPage = currentPage - 1 > 0 ? currentPage - 1 : 1;

      if (currentPage > 3) {
        pages.push(
          <li
            className='inactive'
            key={0}
            onClick={() => {
              this.fetchDeletedManifestHistory(1);
            }}
          >
            <a>1</a>
          </li>,
        );
      }
      if (currentPage > 4) {
        pages.push(
          <li className='inactive' key={1}>
            <a>. . .</a>
          </li>,
        );
      }
      for (let i = startingIndex; i <= lastPageIndex; i++) {
        pages.push(
          <li
            className={i == currentPage ? 'active' : 'inactive'}
            key={i}
            onClick={() => {
              this.fetchDeletedManifestHistory(i);
            }}
          >
            <a>{i}</a>
          </li>,
        );
      }
      if (lastPageIndex + 1 < this.state.deletedHistoryLastPage) {
        pages.push(
          <li className='inactive' key={this.state.deletedHistoryLastPage + 1}>
            <a>. . .</a>
          </li>,
        );
      }
      if (lastPageIndex < this.state.deletedHistoryLastPage) {
        pages.push(
          <li
            className='inactive'
            key={this.state.deletedHistoryLastPage}
            onClick={() => {
              this.fetchDeletedManifestHistory(
                this.state.deletedHistoryLastPage,
              );
            }}
          >
            <a>{this.state.deletedHistoryLastPage}</a>
          </li>,
        );
      }

      if (pages?.length > 0) {
        paginationHtml.push(
          <div
            className='fs-pagination-wrapper-outer custome_old_pagination'
            key={7}
          >
            <div className='fs-pagination-wrapper'>
              <span
                className={`prev ${
                  prevPage === 1 && currentPage === 1 ? 'disabled' : ''
                }`}
                onClick={() => {
                  this.fetchDeletedManifestHistory(prevPage);
                }}
              >
                <img
                  alt='previous'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
              <ul className='fs-pagination'>{pages}</ul>
              <span
                className={`next ${
                  nextPage == this.state.deletedHistoryLastPage
                    ? 'disabled'
                    : ''
                }`}
                onClick={() => {
                  this.fetchDeletedManifestHistory(nextPage);
                }}
              >
                <img
                  alt='next'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
            </div>
          </div>,
        );
      }
    }

    return paginationHtml;
  };

  getEmployeeList() {
    let formData = new FormData();
    formData.append('crew_identifier_id', this.state.id);

    formData.append('active', true);
    formData.append('locked', true);
    formData.append('pagination', false);
    formData.append('guest', true);

    this.props.dispatch(resourceActions.employeeList(formData));
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    var body = document.body;
    body.classList.remove('inv-sidebar-opened');
  }
  deleteHistoryOpenModal = (id) => {
    this.setState({ deleteHistoryOpen: true, historyId: id });
  };

  deleteHistoryCloseModal() {
    this.setState({ deleteHistoryOpen: false, historyId: '' });
  }
  deleteHistory = () => {
    if (this.state.historyId == '') {
      return;
    }
    this.setState({ deleteHistoryOpen: false });
    this.props.dispatch(
      assignmentStatsActions.historyDelete(this.state.historyId),
    );
  };

  getManifestList = (manifestPageNum = 1) => {
    const data = {
      resourceId: this.state.id,
      perPage: 5,
      page: manifestPageNum,
    };
    this.props.dispatch(manifestActions.manifestListV1(data));
  };

  handleScroll(event) {
    var wrap = document.getElementById('right_sidebar'),
      contentHeight = wrap.offsetHeight,
      yOffset = window.pageYOffset,
      y = yOffset + window.innerHeight,
      applicationItem = [],
      sortVariable = '';

    if (this.state.sort !== '' && this.state.sort) {
      sortVariable =
        '&sort=' + this.state.sort + '&order=' + this.state.orderAll
          ? this.state.orderAll
          : 'asc';
    }
    if (y >= contentHeight) {
      let data = this.state.resultData;
      if (data.current_page < data.last_page && this.state.flag !== false) {
        const requestOptions = {
          method: 'GET',
          headers: authHeader(),
        };
        fetch(data.next_page_url + sortVariable, requestOptions)
          .then((res) => {
            return res.json();
          })
          .then((data) => {
            this.setState({ resultData: data.data });

            if (data.data.current_page === data.data.last_page) {
              this.setState({ flag: false });
            }

            var appInf = [];
            data.data.data.map((item, index) => {
              appInf[item.hash] = item.applicant_info;
              this.setState((state) => ({
                applicant_info: { ...state.applicant_info, ...appInf },
              }));

              applicationItem.push(
                <div className='employee_item'>
                  <div className='list_item image-holder second_width'>
                    <img
                      alt={item.first_name + ' ' + item.last_name}
                      className={item.active}
                      src={
                        item.profile_photo
                          ? config.apiUrl + '/' + item.profile_photo
                          : config.apiUrl + '/' + config.altImg
                      }
                      onError={this.onImageError.bind(this)}
                    />
                  </div>
                  <div className='list_item second_width second_width'>
                    <span className={item.colorcode + ' color_code'} />
                    <span className='emp_name'>
                      {item.first_name + ' ' + item.last_name}
                    </span>
                  </div>
                  <div className='list_item second_width'>{item.email}</div>
                  <div
                    className='list_item sendMail_btn second_width'
                    onClick={this.sendMail.bind(this, item.email)}
                  >
                    Send Mail
                  </div>
                  <div
                    className='list_item second_width'
                    onClick={this.removeList.bind(this, item.email)}
                  >
                    <img
                      alt='close'
                      src={require('../assets/images/close_green.png').default}
                      onError={this.onImageError.bind(this)}
                    />
                  </div>
                </div>,
              );
              return applicationItem;
            });
            this.setState({
              applicationItem: [
                ...this.state.applicationItem,
                ...applicationItem,
              ],
            });
          })
          .catch((err) => console.log(err));
      }
    }
  }

  editResourceHistory(item) {
    let assignment = this.state.assigmentStatusHistory.data.find(
      (i) => i.id === item.id,
    );

    this.setState({
      unavailable_end_date: null,
      offDate: null,
    });

    if (assignment) {
      let { id, status, incident_projects, notes, resource_unavailability } =
        assignment;

      if (status == 3) {
        this.setState({
          editMode: true,
          preventAssignmentPopupClick: false,
          assignmentHistoryId: id,
          tempAssignmentStatus: this.state.assignmentStatusOptions[status - 1],
          tempAssignmentType: incident_projects.assignment_type_id,
          initialStatusId: status,
          projectId: incident_projects.id,
          projectName: incident_projects.name || '',
          projectShift: incident_projects.shifts || '',
          onDate: moment(incident_projects.date_on),
          offDate: incident_projects.date_off
            ? moment(incident_projects.date_off)
            : '',
          projectNote: notes || '',
          location: incident_projects.location || '',
          complexity: incident_projects.complexity || '',
          fuel_type: incident_projects.fuel_type || '',
          fire_size: incident_projects.fire_size || '',
          hotline_shifts: incident_projects.hotline_shifts || '',
        });
      } else if (status == 2) {
        this.setState({
          editMode: true,
          preventAssignmentPopupClick: false,
          assignmentHistoryId: id,
          tempAssignmentStatus: this.state.assignmentStatusOptions[status - 1],
          unavailable_reason_id: resource_unavailability.unavailable_reason_id,
          unavailable_start_date: moment(resource_unavailability.start_date),
          unavailable_end_date: resource_unavailability.end_date
            ? moment(resource_unavailability.end_date)
            : '',
          initialStatusId: status,
          projectNote: notes || '',
        });
      }

      document.body.className += ' ' + 'inv-sidebar-opened';
    }
  }

  componentWillReceiveProps(nextProps) {
    window.addEventListener('scroll', this.handleScroll);
    const {
      vehicles,
      employee,
      permission,
      inventory,
      manifest,
      assignmentStats,
      resource,
    } = nextProps;

    if (employee.list) {
      if (employee.list.data) {
        this.setState({ resultData: employee.list.data, flag: false });
      }
    }
    if (manifest?.ManifestList) {
      this.setState({ manifest: manifest });
    }

    if (manifest?.ManifestListV1) {
      this.setState({
        ManifestListV1: manifest.ManifestListV1.data.data,
        manifestPagination: manifest.ManifestListV1.data.pagination,
      });
    }

    if (manifest?.dispatchMailList) {
      this.setState({ dispatchMailList: manifest.dispatchMailList });
    }

    if (this.state.search && employee?.list) {
      let empOptions = [];
      if (employee.list.data?.data) {
        employee.list.data.data.map((item, index) => {
          empOptions.push(
            <li key={index} onClick={this.setMailer.bind(this, item)}>
              {item.first_name + ' ' + item.last_name}
            </li>,
          );
          return empOptions;
        });
      }

      this.setState({
        searchList: empOptions,
        search: false,
        hideSearch: empOptions.length > 0 ? 'show' : 'hide',
      });
    }

    var permList = [],
      stats_array = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
      this.setState({ permList });
    }
    if (inventory.stats) {
      if (inventory.stats.data.stats.length > 0) {
        stats_array.push(<h5 key='title'>Crew Inventory</h5>);
        inventory.stats.data.stats.map((item, index) => {
          stats_array.push(
            <div className='inventory_item' key={index}>
              <div className='inventory_progress'>
                <CircularProgressbar
                  percentage={item.per}
                  textForPercentage={(percentage) => `${item.per}%`}
                  strokeWidth='9'
                />
              </div>
              <div className='inventory_data'>
                <p>{item.value}</p>
                <span className='small_grey'>
                  {item.total + ' Total / ' + item.assigned + ' Assigned'}
                </span>
              </div>
            </div>,
          );
        });
        this.setState({ stats_array });
      }
    }
    if (assignmentStats.applicantStats) {
      let { assignmentStatusOptions } = this.state;
      const manifestStatus =
        assignmentStats.applicantStats.data.manifestStatus ||
        this.state.manifestStatus;

      // Note: currentAssignmentStatus is now set by fetchResourceDetails() API call
      // which uses the resource_availability_status from the backend

      this.setState({
        manifestStatus,
        currentAssignmentDetails: {
          name: assignmentStats.applicantStats.data.summary
            ? assignmentStats.applicantStats.data.summary[0].name
            : '',
          date_off: assignmentStats.applicantStats.data.summary
            ? assignmentStats.applicantStats.data.summary[0].date_off
            : '',
          date_on: assignmentStats.applicantStats.data.summary
            ? assignmentStats.applicantStats.data.summary[0].date_on
            : '',
          assignment_type_id: assignmentStats.applicantStats.data.summary
            ? assignmentStats.applicantStats.data.summary[0].assignment_type_id
            : '',
          assignment_type: assignmentStats.applicantStats.data.summary
            ? assignmentStats.applicantStats.data.summary[0].assignment_type
            : '',
          shifts: assignmentStats.applicantStats.data.summary
            ? assignmentStats.applicantStats.data.summary[0].shifts
            : '',
          notes: assignmentStats.applicantStats.data.notes,
          id: assignmentStats.applicantStats.data.summary
            ? assignmentStats.applicantStats.data.summary[0].id
            : '',
          location:
            assignmentStats.applicantStats.data.summary &&
            assignmentStats.applicantStats.data.summary[0].location,
          complexity:
            assignmentStats.applicantStats.data.summary &&
            assignmentStats.applicantStats.data.summary[0].complexity,
          fuelType:
            assignmentStats.applicantStats.data.summary &&
            assignmentStats.applicantStats.data.summary[0].fuel_type,
          fireSize:
            assignmentStats.applicantStats.data.summary &&
            assignmentStats.applicantStats.data.summary[0].fire_size,
          hotlineShifts:
            assignmentStats.applicantStats.data.summary &&
            assignmentStats.applicantStats.data.summary[0].hotline_shifts,
          manifest_id: assignmentStats.applicantStats.data.summary
            ? assignmentStats.applicantStats.data.summary[0].manifest_id
            : null,
        },
      });

      if (this.state.currentAssignmentDetails?.date_off) {
        const currentDate = new Date();
        this.setState({
          isCrewCommitted:
            new Date(this.state.currentAssignmentDetails?.date_off) >
            currentDate,
        });
      }
    }
    if (assignmentStats.types) {
      this.setState({ assigmentCategoryOptions: assignmentStats.types });
    }
    if (assignmentStats.assignmentHistory) {
      this.setState({
        assigmentStatusHistory: assignmentStats.assignmentHistory.data,
        latestAssignmentHistory:
          assignmentStats.assignmentHistory.additional_data
            ?.latestAssignmentHistory,
      });
    }

    if (assignmentStats.assignmentStatusSaved) {
      if (assignmentStats.assignmentStatusSaved.success) {
        this.props.dispatch(
          assignmentStatsActions.getAssignemntStatus(this.state.id),
        );
        this.getEmployeeList();
        this.props.dispatch(
          assignmentStatsActions.getAssignemntHistory(this.state.id, 1),
        );

        this.setState({
          tempAssignmentStatus: {
            name: '',
            date_off: '',
            date_on: '',
            assignment_type_id: '',
            assignment_type: '',
            shifts: '',
            notes: '',
            id: 0,
          },
        });

        // Refresh resource availability status from API
        this.fetchResourceDetails();
      } else {
        var message = assignmentStats.assignmentStatusSaved.message || {},
          err = [];
        if (Object.keys(message).length) {
          for (var key in message) {
            var ele = message[key];
            var _err = err.push(Array.isArray(ele) ? ele.join(',') : ele);
          }
        }

        if (err.length) {
          this.setState({
            errorMessage: err.join(','),
          });
          setTimeout(() => {
            this.setState({
              errorMessage: '',
            });
            this.props.dispatch(assignmentStatsActions.resetStatus());
          }, 3000);
        }
      }
    }
    if (assignmentStats.historyDelete) {
      this.props.dispatch(
        assignmentStatsActions.getAssignemntStatus(this.state.id),
      );
      this.props.dispatch(
        assignmentStatsActions.getAssignemntHistory(this.state.id, 1),
      );
      // Refresh deleted history list after successful delete
      this.fetchDeletedManifestHistory(this.state.deletedHistoryPage);

      // Refresh resource availability status after history delete
      this.fetchResourceDetails();
    }

    if (resource) {
      if (resource.projects) {
        this.setState({
          incidentProjects: resource.projects,
        });
      }
    }

    if (inventory?.list) {
      this.setState({
        inventoryList: inventory?.list || [],
      });
    }
  }

  onImageError(e) {
    e.target.setAttribute('src', config.apiUrl + '/' + config.altImg);
  }

  keyUpFn(event) {
    var value = event.target.value;
    clearTimeout(this.state.timeout);
    this.state.timeout = setTimeout(
      function () {
        this.handleSearch(value, false);
      }.bind(this),
      1000,
    );
  }

  handleSearch(text, email) {
    let data = new FormData();
    data.append('keyword', text);

    const nextState = {
      search: true,
    };

    if (this.isValidEmail(text)) {
      nextState.validManifestMail = true;
      nextState.manifestEmail = text;
    } else {
      nextState.validManifestMail = false;
      nextState.manifestEmail = '';
    }

    if (!email) {
      data.append('crew_identifier_id', this.state.id);
    }

    this.props.dispatch(resourceActions.employeeList(data));
    this.setState(nextState);
  }

  profile(hash) {
    const { permission } = this.props;

    var permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
    }
    if (permList.includes('View User Profile')) {
      this.props.profile(hash);
    }
  }
  /**
   * function to open slider to edit the assignment status
   */
  editStatus = () => {
    let offDate = null;
    let unavailable_end_date = null;
    if (this.state.latestAssignmentHistory) {
      if (
        this.state.latestAssignmentHistory.incident_projects?.date_on &&
        this.state.currentAssignmentStatus == 'Committed'
      ) {
        offDate =
          currentDate >=
          this.state.latestAssignmentHistory.incident_projects?.date_on
            ? currentDate
            : this.state.latestAssignmentHistory.incident_projects?.date_on;
      } else if (
        this.state.latestAssignmentHistory.resource_unavailability
          ?.start_date &&
        this.state.currentAssignmentStatus == 'Unavailable'
      ) {
        unavailable_end_date =
          currentDate >=
          this.state.latestAssignmentHistory.resource_unavailability?.start_date
            ? currentDate
            : this.state.latestAssignmentHistory.resource_unavailability
                ?.start_date;
      }
    }
    this.setState({
      editMode: false,
      preventAssignmentPopupClick: false,
      tempAssignmentStatus: '',
      tempAssignmentType: '',
      projectId: null,
      projectName: '',
      projectShift: '',
      initialStatusId: null,
      onDate: moment(),
      offDate: offDate ? moment(offDate) : null,
      unavailable_end_date: unavailable_end_date
        ? moment(unavailable_end_date)
        : null,
      projectNote: '',
      location: '',
      complexity: '',
      fuel_type: '',
      fire_size: '',
      hotline_shifts: '',
    });

    document.body.className += ' ' + 'inv-sidebar-opened';
  };

  editManifestStatus = () => {
    const isPending = this.state.manifestStatus === 'pending';
    const currentAssignmentDetails = this.state.currentAssignmentDetails;

    // Determine onDate: use date_on if pending and available, otherwise use currentDate
    const onDate =
      isPending && currentAssignmentDetails.date_on
        ? moment(currentAssignmentDetails.date_on)
        : moment(currentDate);

    // Determine offDate: use date_off if pending and available, otherwise null
    const offDate =
      isPending && currentAssignmentDetails.date_off
        ? moment(currentAssignmentDetails.date_off)
        : null;

    this.setState({
      editMode: false,
      preventAssignmentPopupClick: false,
      tempAssignmentStatus: '',
      tempAssignmentType: '',
      projectId: null,
      projectName: currentAssignmentDetails.name || '',
      projectShift: '',
      initialStatusId: null,
      onDate,
      offDate,
      unavailable_end_date: null,
      projectNote: this.state.currentAssignmentDetails.notes || '',
      location: this.state.currentAssignmentDetails.location || '',
      complexity: this.state.currentAssignmentDetails.complexity || '',
      fuel_type: this.state.currentAssignmentDetails.fuelType || '',
      fire_size: this.state.currentAssignmentDetails.fireSize || '',
      hotline_shifts: '',
      // Initialize manifest close out fields (for inuse)
      manifestCloseOutDateOff: null,
      manifestCloseOutHotlineShifts: '',
      manifestCloseOutNotes: '',
      isManifestCloseOut: true, // Manifest close out/commit mode
      fireHistoryManifestId:
        this.state.currentAssignmentDetails.manifest_id || null,
    });

    document.body.className += ' ' + 'inv-sidebar-opened';
  };
  /**
   * function to handle the change in assignment status to make the changes in the form based on selected value
   */
  handleAssignmentChange = (event) => {
    this.setState({
      tempAssignmentStatus: event.target.value,
      unavailable_start_date:
        event.target.value == 'Unavailable' ? moment(currentDate) : null,
      unavailable_end_date:
        event.target.value == 'Available' &&
        this.state.unavailabilityDetails?.end_date
          ? moment(this.state.unavailabilityDetails.end_date)
          : event.target.value == 'Unavailable'
            ? null
            : this.state.unavailable_end_date,
    });
  };

  handleFireHistoryAssignModal = () => {
    switch (this.state?.typeSlug) {
      case FIRE_HISTORY_TYPE_SLUG?.AUTO_ASSIGN_MANIFEST:
        this.saveAssignmentChanges();
        this.setState({ enableAssignEmployeeModal: false });
        break;
      case FIRE_HISTORY_TYPE_SLUG?.MANUAL_ASSIGN_MANIFEST:
        this?.sortYourCrewRef?.current?.toVehicle((res) => {
          if (res?.length) {
            this.setState(
              {
                manualAssignManifestIds: res?.map((item) => item?.userid),
                enableAssignEmployeeModal: false,
              },
              () => {
                this.saveAssignmentChanges();
              },
            );
          }
        });
        break;
    }
  };

  handleAutoAssignModalClose() {
    this.setState({ enableAssignEmployeeModal: false, typeSlug: null });
  }
  /**
   * function to close slider to edit the assignment status
   */
  closeStatusPopup = () => {
    document.body.classList.remove('inv-sidebar-opened');
    this.setState({
      location: '',
      complexity: '',
      fuel_type: '',
      fire_size: '',
      hotline_shifts: '',
      manifestCloseOutDateOff: null,
      manifestCloseOutHotlineShifts: '',
      manifestCloseOutNotes: '',
      isManifestCloseOut: false,
    });
  };

  // get unavailable reasons
  getUnavailableReasons() {
    const _requestOptions = {
      method: 'GET',
      headers: authHeader(),
    };
    const _url = `${config.apiUrl}/api/getlist/unavailablereason`;
    fetch(_url, _requestOptions).then((response) =>
      response.json().then(
        (res) => {
          this.setState({ unavailable_reasons: res });
        },
        (err) => console.error(err),
      ),
    );
  }

  editAssignmentConfirmation = (e) => {
    this.setState(
      {
        displayEditAssignmentConfirmPopup: false,
        confirmEditAssignment: true,
      },
      () => {
        this.saveAssignmentChanges(e);
      },
    );
  };

  closeEditAssignmentConfirmPopup = () => {
    this.setState({
      displayEditAssignmentConfirmPopup: false,
    });
  };

  handleCloseManifest = async (data) => {
    try {
      this.setState({
        preventAssignmentPopupClick: true,
      });

      await this.props.dispatch(manifestActions.closeManifest(data));

      toast.success('Manifest closed out successfully!');
      this.setState({
        preventAssignmentPopupClick: false,
        isManifestCloseOut: false,
      });
      this.closeStatusPopup();
      this.fetchData(); // Refresh data to get updated manifest status
    } catch (error) {
      toast.error('Failed to close out manifest');
      console.error('Manifest close out error:', error);
      this.setState({
        preventAssignmentPopupClick: false,
      });
    }
  };

  handleCommitManifest = async () => {
    try {
      this.setState({
        preventAssignmentPopupClick: true,
        commitManifestLoading: true,
      });

      // Get manifestId from fireHistoryManifestId or currentAssignmentDetails
      const manifestId =
        this.state.fireHistoryManifestId ||
        this.state.currentAssignmentDetails?.manifest_id;

      if (!manifestId) {
        this.setState({
          preventAssignmentPopupClick: false,
          commitManifestLoading: false,
        });
        return toast.error('Manifest ID is required.');
      }

      const payload = {
        manifestId: manifestId,
        resourceIdentifierId: this.state.id,
        dateOn: moment(this.state.onDate).format('YYYY-MM-DD'),
        assignmentType: Number(this.refs.AssignmentType.value),
        dateOff: this.state.offDate
          ? moment(this.state.offDate).format('YYYY-MM-DD')
          : null,
        shifts: this.state.projectShift || null,
        location: this.state.location || null,
        complexity: this.state.complexity || null,
        fuelType: this.state.fuel_type || null,
        fireSize: this.state.fire_size || null,
        hotlineShifts: null,
        notes: this.refs.note?.value || null,
      };

      const res = await fetch(
        config.apiUrl + '/api/v1/manifests/commit-manifest',
        {
          method: 'POST',
          headers: { ...authHeader(), 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        },
      );

      const data = await res.json();

      if (data?.status === 'success') {
        toast.success('Manifest committed successfully!');

        this.setState(
          {
            preventAssignmentPopupClick: false,
            isManifestCloseOut: false,
            commitManifestLoading: false,
          },
          () => {
            this.fetchData();
            this.closeStatusPopup();

            // Fetch dispatch mail list and open email manifest modal
            // Use setTimeout to ensure the status popup is closed and fetchData has started
            setTimeout(() => {
              // Fetch dispatch mail list
              this.props.dispatch(manifestActions.dispatchMailList());

              // Open email manifest modal
              this.setState({ emailManifestModalOpen: true });
            }, 500);
          },
        );
      } else {
        const errorMsg = data?.message || 'Failed to commit manifest';
        toast.error(
          typeof errorMsg === 'string'
            ? errorMsg
            : Array.isArray(errorMsg)
              ? errorMsg.join(', ')
              : 'Failed to commit manifest',
        );
        this.setState({
          preventAssignmentPopupClick: false,
          commitManifestLoading: false,
        });
      }
    } catch (error) {
      toast.error('Failed to commit manifest');
      console.error('Manifest commit error:', error);
      this.setState({
        preventAssignmentPopupClick: false,
        commitManifestLoading: false,
      });
    }
  };

  closeEmailManifestModal = () => {
    this.setState({
      emailManifestModalOpen: false,
      mailList: [],
      mailSearchKeyword: '',
      hideSearch: 'hide',
      validManifestMail: false,
      manifestEmail: '',
    });
    if (document.getElementById('txtSearchManiEmployees')) {
      document.getElementById('txtSearchManiEmployees').value = '';
    }
  };

  handleSendEmailManifest = () => {
    const manifestId = this.state.currentAssignmentDetails?.manifest_id;
    if (!manifestId) {
      return toast.error('Manifest ID not found.');
    }

    let data = new FormData();
    data.append('manifest_id', manifestId);
    data.append('resource_id', this.state.id);
    let toList = this.state.dispatchMailList;

    if (this.state.mailList?.length > 0) {
      toList = [...toList, ...this.state.mailList.map((item) => item.email)];
    }

    data.append('to', toList.join());

    this.props.dispatch(manifestActions.emailManifest(data));
    this.fetchData();
    this.closeEmailManifestModal();
    toast.success('Email sent successfully!');
  };

  isValidEmail(email) {
    const re = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
    return re.test(email);
  }

  emailChangeFn(event) {
    var value = event.target.value;
    this.setState(
      {
        mailSearchKeyword: value,
        validManifestMail: false,
      },
      () => {
        clearTimeout(this.state.timeout);
        this.state.timeout = setTimeout(
          function () {
            this.handleSearch(value, true);
          }.bind(this),
          1000,
        );
      },
    );
  }

  addManifestEmail() {
    if (this.state.validManifestMail) {
      this.setState({
        mailSearchKeyword: '',
        hideSearch: 'hide',
        mailList: [
          ...this.state.mailList,
          {
            first_name: '-',
            last_name: '-',
            email: this.state.manifestEmail,
          },
        ],
      });
    }
  }

  removeList(index) {
    if (index >= 0) {
      let mailList = Object.assign([], this.state.mailList);
      mailList.splice(index, 1);
      this.setState({ mailList: mailList });
      if (document.getElementById('txtSearchManiEmployees')) {
        document.getElementById('txtSearchManiEmployees').value = '';
      }
    }
  }

  removeDispatchList(index) {
    if (index >= 0) {
      let mailList = Object.assign([], this.state.dispatchMailList);
      mailList.splice(index, 1);
      this.setState({ dispatchMailList: mailList });
      if (document.getElementById('txtSearchManiEmployees')) {
        document.getElementById('txtSearchManiEmployees').value = '';
      }
    }
  }

  setMailer(item) {
    this.setState({
      mailList: [...this.state.mailList, item],
      searchList: [],
      hideSearch: 'hide',
    });
  }

  // Handle Resource Status Update (Available/Unavailable)
  handleResourceStatusUpdate = async () => {
    try {
      this.setState({
        preventAssignmentPopupClick: true,
      });

      // Prepare data for the new API
      const data = {
        resource_identifier_id: this.state.id,
        resource_status: this.state.tempAssignmentStatus.toLowerCase(),
        notes: this.state.projectNote || '',
      };

      // Validation for Available status
      if (this.state.tempAssignmentStatus === 'Available') {
        if (!this.state.unavailable_end_date) {
          this.setState({ preventAssignmentPopupClick: false });
          return toast.error('Unavailable end date is required.');
        }
        data.end_date = moment(this.state.unavailable_end_date).format(
          'YYYY-MM-DD',
        );
      }

      // Add unavailable-specific fields
      if (this.state.tempAssignmentStatus === 'Unavailable') {
        data.unavailable_reason_id = this.state.unavailable_reason_id;
        data.start_date = moment(this.state.unavailable_start_date).format(
          'YYYY-MM-DD',
        );
        data.end_date = moment(this.state.unavailable_end_date).format(
          'YYYY-MM-DD',
        );
      }

      // Call the new API
      const response = await manifestService.updateResourceStatus(data);

      if (response.status === 'success') {
        this.setState(
          {
            preventAssignmentPopupClick: false,
          },
          () => {
            this.fetchData();
            toast.success('Resource status updated successfully!');
            this.closeStatusPopup();
          },
        );
      } else {
        this.setState({ preventAssignmentPopupClick: false });
        toast.error('Failed to update resource status');
      }
    } catch (error) {
      this.setState({
        preventAssignmentPopupClick: false,
      });
      console.error('Error updating resource status:', error);
      toast.error('Failed to update resource status');
    }
  };

  // Submit Assignment Changes
  saveAssignmentChanges = (event) => {
    event?.preventDefault();

    // Handle manifest close out case (when opened from Manifest Status: In Use)
    if (
      this.state.isManifestCloseOut &&
      this.state.manifestStatus === 'inuse'
    ) {
      if (!this.state.manifestCloseOutDateOff) {
        return toast.error('Date Off is a required field.');
      }
      if (!this.state.manifestCloseOutHotlineShifts) {
        return toast.error('Hotline Shifts is a required field.');
      }

      // Get manifest ID from current assignment details
      const manifestId = this.state.currentAssignmentDetails?.manifest_id;
      if (!manifestId) {
        return toast.error('Manifest ID not found.');
      }

      // Prepare data for manifest close out
      const data = {
        manifestId: manifestId,
        resourceIdentifierId: this.state.id,
        dateOff: moment(this.state.manifestCloseOutDateOff).format(
          'YYYY-MM-DD',
        ),
        hotlineShifts: parseInt(this.state.manifestCloseOutHotlineShifts),
        notes: this.state.manifestCloseOutNotes || '',
      };

      // Call the close manifest API
      this.handleCloseManifest(data);
      return;
    }

    // Handle manifest commit case (when opened from Manifest Status: Manifest Pending)
    if (
      this.state.isManifestCloseOut &&
      this.state.manifestStatus === 'pending'
    ) {
      if (!this.refs.AssignmentType?.value) {
        return toast.error('Assignment Type is a required field.');
      }
      if (!this.state.fireHistoryManifestId) {
        return toast.error('Manifest is a required field.');
      }
      if (!this.state.onDate) {
        return toast.error('Date On is a required field.');
      }

      this.handleCommitManifest();
      return;
    }

    // Handle Available and Unavailable status with new API (when opened from Current Status)
    // Only use this API when NOT in edit mode and tempAssignmentStatus is a valid value
    if (
      !this.state.editMode &&
      (this.state.resourceAvailabilityStatus === 'available' ||
        this.state.resourceAvailabilityStatus === 'unavailable') &&
      (this.state.tempAssignmentStatus === 'Available' ||
        this.state.tempAssignmentStatus === 'Unavailable')
    ) {
      this.handleResourceStatusUpdate();
      return;
    }

    if (this.state.editMode && !this.state.confirmEditAssignment) {
      return this.setState({
        displayEditAssignmentConfirmPopup: true,
      });
    }
    if (!this.state.tempAssignmentStatus) {
      return toast.error('Please select an assignment status.');
    }
    if (!this.state.editMode) {
      if (
        this.state.currentAssignmentStatus == 'Committed' &&
        !this.state.hotline_shifts
      ) {
        return toast.error('Hotline Shifts is a required field.');
      }
      if (
        this.state.currentAssignmentStatus == 'Unavailable' &&
        !this.state.unavailable_end_date
      ) {
        return toast.error('Unavailable end date is a required field.');
      }
    }
    this.setState({
      preventAssignmentPopupClick: true,
    });
    let index = this.state.assignmentStatusOptions.findIndex(
      (x) => x == this.state.tempAssignmentStatus,
    );
    let data = new FormData();
    data.append('status', index + 1);
    data.append('resource_identifier_id', this.state.id);
    data.append('location', this.state.location);
    data.append('complexity', this.state.complexity);
    data.append('fuel_type', this.state.fuel_type);
    data.append('fire_size', this.state.fire_size);
    if (this.state.hotline_shifts) {
      data.append('hotline_shifts', this.state.hotline_shifts);
    }
    if (this.state.offDate) {
      data.append('date_off', moment(this.state.offDate).format('YYYY-MM-DD'));
    }
    if (this.state.unavailable_start_date) {
      data.append(
        'unavailable_start_date',
        moment(this.state.unavailable_start_date).format('YYYY-MM-DD'),
      );
    }
    if (this.state.unavailable_end_date) {
      data.append(
        'unavailable_end_date',
        moment(this.state.unavailable_end_date).format('YYYY-MM-DD'),
      );
    }
    if (this.state.editMode == true) {
      data.append('assignment_history_id', this.state.assignmentHistoryId);
    }

    if (this.state.tempAssignmentStatus == 'Committed') {
      if (!this.refs.AssignmentType.value) {
        this.setState({
          preventAssignmentPopupClick: false,
        });
        return toast.error('Assigment Type is a required field');
      }
      if (!this.state.editMode && !this.state?.fireHistoryManifestId) {
        this.setState({
          preventAssignmentPopupClick: false,
        });
        return toast.error('Manifest is a required field');
      }
      data.append('assignment_type', this.refs.AssignmentType.value);

      if (this.state.editMode == true) {
        if (this.refs.ProjectName) {
          data.append('name', this.refs.ProjectName.value);
          data.append(
            'date_on',
            moment(this.state.onDate).format('YYYY-MM-DD'),
          );
          if (this.refs.totalShifts?.value) {
            data.append('shifts', this.refs.totalShifts.value);
          }
        }
        data.append('notes', this.refs.note.value);
      } else if (this.state.editMode == false) {
        data.append('name', this.refs.ProjectName.value);
        data.append('assignment_type', this.refs.AssignmentType.value);
        data.append('date_on', moment(this.state.onDate).format('YYYY-MM-DD'));
        if (this.state.offDate) {
          data.append(
            'date_off',
            moment(this.state.offDate).format('YYYY-MM-DD'),
          );
        }
        if (this.refs.totalShifts?.value) {
          data.append('shifts', this.refs.totalShifts.value);
        }
        data.append('notes', this.refs.note.value);
      }
    }

    this.state.tempAssignmentStatus === 'Unavailable' &&
      data.append('unavailable_reason_id', this.state.unavailable_reason_id);

    if (this.state.tempAssignmentStatus !== 'Committed') {
      data.append('notes', this.refs.note.value);
    }

    // Fire history
    if (this.state.tempAssignmentStatus == 'Committed') {
      if (this.state?.fireHistoryManifestId) {
        data.append('type_slug', this.state?.typeSlug);
        data.append('manifest_id', this.state?.fireHistoryManifestId);
      } else if (
        this.state?.typeSlug === FIRE_HISTORY_TYPE_SLUG?.AUTO_ASSIGN_MANIFEST
      ) {
        data.append('type_slug', this.state?.typeSlug);
      } else if (
        this.state?.typeSlug ===
          FIRE_HISTORY_TYPE_SLUG?.MANUAL_ASSIGN_MANIFEST &&
        this?.state?.manualAssignManifestIds?.length
      ) {
        data.append('type_slug', this.state?.typeSlug);
        data.append(
          'employees_fire_report',
          JSON.stringify(this.state?.manualAssignManifestIds),
        );
      } else {
        this.closeStatusPopup(true);
        return this.setState({
          enableAssignEmployeeModal: true,
          typeSlug: FIRE_HISTORY_TYPE_SLUG?.AUTO_ASSIGN_MANIFEST,
        });
      }
    }

    this.handleSaveStatus(data);

    if (this.refs.note) this.refs.note.value = '';
  };

  handleSaveStatus = async (data) => {
    try {
      await this.props.dispatch(assignmentStatsActions.saveStatus(data));
      this.setState(
        {
          preventAssignmentPopupClick: false,
        },
        () => {
          this.fetchData();
          toast.success('Assignment status saved successfully!');
          this.closeStatusPopup();
        },
      );
    } catch (error) {
      this.setState({
        preventAssignmentPopupClick: false,
      });
      const parsedError = JSON.parse(error);
      if (typeof parsedError.message == 'string') {
        toast.error(`Failed to save assignment status: ${parsedError.message}`);
      } else {
        toast.error(`Failed to save assignment status`);
      }
    }
  };

  getHistoryList = (pageNum) => {
    this.props.dispatch(
      assignmentStatsActions.getAssignemntHistory(this.state.id, pageNum),
    );
  };

  inventoryPagination() {
    if (this.state.inventoryList && this.state.inventoryList.length > 0) {
      let pages = [];

      let currentPage = this.state.inventoryPage;
      let startingIndex = currentPage - 2 > 0 ? currentPage - 2 : 1;
      let lastPageIndex =
        currentPage + 2 < this.state.inventoryLastPage
          ? currentPage + 2
          : this.state.inventoryLastPage;
      let nextPage =
        currentPage + 1 > this.state.inventoryLastPage
          ? this.state.inventoryLastPage
          : currentPage + 1;
      let prevPage = currentPage - 1 > 0 ? currentPage - 1 : 1;

      if (currentPage > 3) {
        pages.push(
          <li
            className='inactive'
            key={0}
            onClick={() => {
              this.getInventoryList(1);
            }}
          >
            <a>1</a>
          </li>,
        );
      }
      if (currentPage > 4) {
        pages.push(
          <li className='inactive' key={1}>
            <a>. . .</a>
          </li>,
        );
      }
      for (let i = startingIndex; i <= lastPageIndex; i++) {
        // getManifestList
        pages.push(
          <li
            className={i == currentPage ? 'active' : 'inactive'}
            key={i}
            onClick={() => {
              this.getInventoryList(i);
            }}
          >
            <a>{i}</a>
          </li>,
        );
      }
      if (lastPageIndex + 1 < this.state.inventoryLastPage) {
        pages.push(
          <li className='inactive' key={this.state.inventoryLastPage + 1}>
            <a>. . .</a>
          </li>,
        );
      }
      if (lastPageIndex < this.state.inventoryLastPage) {
        pages.push(
          <li
            className='inactive'
            key={this.state.inventoryLastPage}
            onClick={() => {
              this.getInventoryList(this.state.inventoryLastPage);
            }}
          >
            <a>{this.state.inventoryLastPage}</a>
          </li>,
        );
      }

      if (pages.length > 0) {
        return (
          <div
            className='fs-pagination-wrapper-outer custome_old_pagination'
            key={7}
          >
            <div className='fs-pagination-wrapper'>
              <span
                className={`prev ${
                  prevPage === 1 && currentPage === 1 ? 'disabled' : ''
                }`}
                onClick={() => {
                  this.getInventoryList(prevPage);
                }}
              >
                <img
                  alt='previous'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
              <ul className='fs-pagination'>{pages}</ul>
              <span
                className={`next ${
                  nextPage == this.state.inventoryLastPage ? 'disabled' : ''
                }`}
                onClick={() => {
                  this.getInventoryList(nextPage);
                }}
              >
                <img
                  alt='previous'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
            </div>
          </div>
        );
      }
    } else {
      return (
        <div className='applicant_item' key='noEmployees'>
          <p>No Inventory Assigned!</p>
        </div>
      );
    }
  }

  getInventoryList(page) {
    let { inventoryLastPage } = this.state;
    if (page && page >= 1 && page <= inventoryLastPage) {
      this.props
        .dispatch(
          inventoryActions.getPaginatedList({ id: this.state.id, page }),
        )
        .then((res) => {
          this.setState({
            inventoryList: res.data || [],
            inventoryPage: res.current_page,
            inventoryLastPage: res.last_page,
            inventoryPerPage: res.per_page,
          });
        });
    }
  }

  render() {
    const { vehicles, employee, permission, manifest } = this.props;
    const { persist } = this.props.assignmentStats;
    const { complexity, fuelType, fireSize } = persist;
    let crew_data = null;
    this.props.assignmentStats?.applicantStats &&
      (crew_data = this.props.assignmentStats.applicantStats.data);
    var permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
    }
    let paginationHistoryHtml = [];
    var vehiclesOption = [];
    var manifestsOption = [];
    let paginationHtml = [];
    var employeesOption = [];

    let { inventoryList, inventoryPage, inventoryPerPage } = this.state;

    const availableEmployees = this.state.resultData.data?.filter(
      (employee) => !employee.is_locked && !employee.is_guest,
    );
    const pendingEmployees = this.state.resultData.data?.filter(
      (employee) => employee.is_guest,
    );
    const lockedEmployees = this.state.resultData.data?.filter(
      (employee) => employee.is_locked && !employee.is_guest,
    );

    if (this.state.assigmentStatusHistory.data.length > 0) {
      let pages = [];
      let currentPage = this.state.assigmentStatusHistory.current_page;
      let startingIndex = currentPage - 2 > 0 ? currentPage - 2 : 1;
      let lastPageIndex =
        currentPage + 2 < this.state.assigmentStatusHistory.last_page
          ? currentPage + 2
          : this.state.assigmentStatusHistory.last_page;
      let nextPage =
        currentPage + 1 > this.state.assigmentStatusHistory.last_page
          ? this.state.assigmentStatusHistory.last_page
          : currentPage + 1;
      let prevPage = currentPage - 1 > 0 ? currentPage - 1 : 1;
      if (currentPage > 3) {
        pages.push(
          <li
            className='inactive'
            key={0}
            onClick={() => {
              this.getHistoryList(1);
            }}
          >
            <a>1</a>
          </li>,
        );
      }
      if (currentPage > 4) {
        pages.push(
          <li className='inactive' key={1}>
            <a>. . .</a>
          </li>,
        );
      }
      for (let i = startingIndex; i <= lastPageIndex; i++) {
        // getManifestList
        pages.push(
          <li
            className={i == currentPage ? 'active' : 'inactive'}
            key={i}
            onClick={() => {
              this.getHistoryList(i);
            }}
          >
            <a>{i}</a>
          </li>,
        );
      }
      if (
        lastPageIndex + 1 <
        this.state.assigmentStatusHistory.data.last_page
      ) {
        pages.push(
          <li
            className='inactive'
            key={this.state.assigmentStatusHistory.data.last_page + 1}
          >
            <a>. . .</a>
          </li>,
        );
      }
      if (lastPageIndex < this.state.assigmentStatusHistory.data.last_page) {
        pages.push(
          <li
            className='inactive'
            key={this.state.assigmentStatusHistory.data.last_page}
            onClick={() => {
              this.getHistoryList(
                this.state.assigmentStatusHistory.data.last_page,
              );
            }}
          >
            <a>{this.state.assigmentStatusHistory.data.last_page}</a>
          </li>,
        );
      }

      if (pages.length > 0) {
        paginationHistoryHtml.push(
          <div
            className='fs-pagination-wrapper-outer custome_old_pagination'
            key={7}
          >
            <div className='fs-pagination-wrapper'>
              <span
                className={`prev ${
                  prevPage === 1 && currentPage === 1 ? 'disabled' : ''
                }`}
                onClick={() => {
                  this.getHistoryList(prevPage);
                }}
              >
                <img
                  alt='previous'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
              <ul className='fs-pagination'>{pages}</ul>
              <span
                className={`next ${
                  nextPage == this.state.assigmentStatusHistory.data.last_page
                    ? 'disabled'
                    : ''
                }`}
                onClick={() => {
                  this.getHistoryList(nextPage);
                }}
              >
                <img
                  alt='previous'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
            </div>
          </div>,
        );
      }
    }
    if (vehicles.items) {
      if (vehicles.items.data.length > 0) {
        vehicles.items.data.map((item, index) => {
          vehiclesOption.push(
            <div className='applicant_item' key={index}>
              <div className='basic_info'>
                <a
                  href={config.baseUrl + 'inventory/inventory-view/' + item.eid}
                  className='vehicleLink'
                >
                  <div className='appln_name'>{item.name}</div>
                  <div className='appln_email'>
                    {item.user
                      ? item.user.first_name + ' ' + item.user.last_name
                      : ''}
                  </div>
                  <div className='appln_phone'>
                    {item.user ? item.user.drivers_license : ''}
                  </div>
                  <div className='appln_date'>{item.vehicle_model_or_make}</div>
                  <div className='appln_area'>
                    {item.vehicle_license === unDefined
                      ? ''
                      : item.vehicle_license}
                  </div>
                </a>
              </div>
            </div>,
          );
        });
      } else {
        vehiclesOption.push(
          <div className='applicant_item' key='noVehicles'>
            <p>No Vehicles added!</p>
          </div>,
        );
      }
    }

    if (employee?.list) {
    }

    // Use V1 API pagination data if available, otherwise fall back to old data
    const paginationData =
      this.state.manifestPagination || manifest?.ManifestList?.data;

    // Build pagination if we have pagination data
    if (
      paginationData &&
      paginationData.current_page &&
      paginationData.last_page
    ) {
      let pages = [];
      let currentPage = paginationData.current_page;
      let startingIndex = currentPage - 2 > 0 ? currentPage - 2 : 1;
      let lastPageIndex =
        currentPage + 2 < paginationData.last_page
          ? currentPage + 2
          : paginationData.last_page;
      let nextPage =
        currentPage + 1 > paginationData.last_page
          ? paginationData.last_page
          : currentPage + 1;
      let prevPage = currentPage - 1 > 0 ? currentPage - 1 : 1;

      if (currentPage > 3) {
        pages.push(
          <li
            className='inactive'
            key={0}
            onClick={() => {
              this.getManifestList(1);
            }}
          >
            <a>1</a>
          </li>,
        );
      }
      if (currentPage > 4) {
        pages.push(
          <li className='inactive' key={paginationData.last_page + 1}>
            <a>. . .</a>
          </li>,
        );
      }
      for (let i = startingIndex; i <= lastPageIndex; i++) {
        pages.push(
          <li
            className={i == currentPage ? 'active' : 'inactive'}
            key={i}
            onClick={() => {
              this.getManifestList(i);
            }}
          >
            <a>{i}</a>
          </li>,
        );
      }
      if (lastPageIndex + 1 < paginationData.last_page) {
        pages.push(
          <li className='inactive' key={paginationData.last_page + 1}>
            <a>. . .</a>
          </li>,
        );
      }
      if (lastPageIndex < paginationData.last_page) {
        pages.push(
          <li
            className='inactive'
            key={paginationData.last_page}
            onClick={() => {
              this.getManifestList(paginationData.last_page);
            }}
          >
            <a>{paginationData.last_page}</a>
          </li>,
        );
      }
      if (pages?.length > 0) {
        paginationHtml.push(
          <div
            className='fs-pagination-wrapper-outer custome_old_pagination'
            key={7}
          >
            <div className='fs-pagination-wrapper'>
              <span
                className={`prev ${
                  prevPage === 1 && currentPage === 1 ? 'disabled' : ''
                }`}
                onClick={() => {
                  this.getManifestList(prevPage);
                }}
              >
                <img
                  alt='previous'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
              <ul className='fs-pagination'>{pages}</ul>
              <span
                className={`next ${
                  nextPage == paginationData.last_page ? 'disabled' : ''
                }`}
                onClick={() => {
                  this.getManifestList(nextPage);
                }}
              >
                <img
                  alt='previous'
                  src={require('../assets/icons/next_arrow.svg').default}
                />
              </span>
            </div>
          </div>,
        );
      }
    }

    // Populate manifestsOption from ManifestListV1 - Match ResourceDetails.jsx structure
    const manifestData = this.state.ManifestListV1;

    if (manifestData && manifestData.length > 0) {
      const manifests = manifestData;
      const allRows = [];

      manifests.forEach((item, manifestIndex) => {
        // Transform each manifest item
        const manifest = {
          manifestId: item.manifest_id || item.mid,
          abbreviation: item.abbreviation || '',
          contractNumber: item.contract_number || '-',
          incidentName: item.incident_name || '',
          resourceNumber: item.resource_number || '',
          addedDate: item.added_date || '',
          dateAssigned: item.date_assigned || '',
          resourceOrderFormExists: item.resource_order_form_exists,
          resourceOrderName: item.resource_order_name,
          assignmentStatus: item.assignment_status,
          manifestAvailability: item.manifest_availability,
          baseManifestId: item.bid || item.base_manifest_id,
          hasLatestVersion: item.has_latest_version,
          resourceOrderFormType: item.resource_order_form_type,
          resourceOrderForm: item.resource_order_form,
          versions: item.versions || [],
        };

        // Determine if there are multiple versions
        const hasMultipleVersions = manifest.versions.length > 1;

        // Render each manifest record independently
        allRows.push(
          <React.Fragment key={`${manifest.manifestId}-${manifestIndex}`}>
            <CustomToolTip
              label={this.getStatusLabel(manifest.manifestAvailability)}
              customClass={'fs-tooltip'}
            >
              <div
                className={`employee_item manifest-row manifest-status-${this.getStatusClass(
                  manifest.manifestAvailability,
                )}`}
              >
                <div className='list_item'>{manifest.abbreviation}</div>
                <div className='list_item'>{manifest.contractNumber}</div>
                <div className='list_item'>
                  <div className='incident_name_wrapper'>
                    <div className='incident_name'>{manifest.incidentName}</div>
                  </div>
                </div>
                <div className='list_item'>{manifest.resourceNumber}</div>
                <div className='list_item'>
                  {manifest.resourceOrderFormExists === 1 &&
                  manifest.resourceOrderName ? (
                    <a
                      className=''
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => {
                        e.preventDefault();
                        this.handleViewResourceOrderForm(manifest);
                      }}
                    >
                      View RO
                    </a>
                  ) : (
                    '-'
                  )}
                </div>
                <div className='list_item'>
                  {formatDate(manifest.addedDate)}
                </div>
                <div className='list_item'>
                  {manifest.dateAssigned
                    ? formatDate(manifest.dateAssigned)
                    : '-'}
                </div>
                <div className='list_item manifest-history-column'>
                  {hasMultipleVersions && (
                    <img
                      src={require('../assets/icons/history_24dp.svg').default}
                      alt='View manifest'
                      className='manifest-history-icon'
                      onClick={() => {
                        // Handle view manifest history if needed
                      }}
                    />
                  )}
                </div>
              </div>
            </CustomToolTip>
          </React.Fragment>,
        );
      });

      // Push all rows wrapped in a single manifest_items container
      if (allRows.length > 0) {
        manifestsOption.push(
          <React.Fragment key='all-manifests-wrapper'>
            <div className='manifest_items'>{allRows}</div>
          </React.Fragment>,
        );
      }
    } else {
      manifestsOption.push(
        <div className='applicant_item' key='noEmployees'>
          <p>No active or used Manifest added!</p>
        </div>,
      );
    }

    if (!this.state.flag) {
      return (
        <div className='resource_container your_crew_div'>
          <div className='page_title float'>
            <h1>{this.state.resource_name}</h1>
          </div>

          <div className='applicants_inner_head crew_outer'>
            <div
              className='inner_container col-lg-12 crew_wrapper'
              id='applicants_inner'
            >
              {this.state.permList.includes('Assignment Status') && (
                <React.Fragment>
                  <div className='assignment-status'>
                    {this.state.errorMessage != '' && (
                      <div
                        className='message-display-div alert alert-danger'
                        role='alert'
                      >
                        {this.state.errorMessage}
                      </div>
                    )}

                    <h5>Assignment Status</h5>
                    <div className='status-wrapper'>
                      <div className='row'>
                        <div className='col-sm-4'>
                          <div className='status-left-box'>
                            <div className='current-status'>
                              <h5>Current Status</h5>
                              {this.state.resourceAvailabilityStatus ==
                                'committed' && (
                                <div className='committed'>
                                  <span className='status-image'>
                                    <img
                                      src={
                                        require('../assets/images/committed.svg')
                                          .default
                                      }
                                    />
                                  </span>
                                  {this.state.currentAssignmentStatus}
                                </div>
                              )}
                              {this.state.resourceAvailabilityStatus ==
                                'available' && (
                                <div className='available'>
                                  <span className='status-image'>
                                    <img
                                      src={
                                        require('../assets/images/tick.svg')
                                          .default
                                      }
                                    />
                                  </span>
                                  {this.state.currentAssignmentStatus}
                                </div>
                              )}
                              {this.state.resourceAvailabilityStatus ==
                                'unavailable' && (
                                <div className='unavailable'>
                                  <span className='status-image'>
                                    <img
                                      src={
                                        require('../assets/images/unavailable.svg')
                                          .default
                                      }
                                    />
                                  </span>
                                  {this.state.currentAssignmentStatus}
                                </div>
                              )}
                              {permList.includes('Status Change Resource') &&
                                this.state.currentAssignmentStatus !==
                                  'Committed' && (
                                  <span
                                    className='editor'
                                    onClick={this.editStatus}
                                  >
                                    <img
                                      src={
                                        require('../assets/images/edit.svg')
                                          .default
                                      }
                                    />
                                  </span>
                                )}
                              {this.state.resourceAvailabilityStatus ==
                                'unavailable' &&
                                this.state.unavailabilityDetails?.end_date !==
                                  null && (
                                  <div
                                    className='unavailability-message'
                                    style={{
                                      marginTop: '10px',
                                      fontSize: '14px',
                                      color: '#666',
                                    }}
                                  >
                                    The crew will remain Unavailable until{' '}
                                    {formatDate(
                                      this.state.unavailabilityDetails.date_off,
                                    )}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>

                        <div className='col-sm-8'>
                          <div className='summary-box'>
                            <h5>Summary</h5>
                            {(this.state.currentAssignmentStatus ==
                              'Committed' ||
                              this.state.manifestStatus === 'pending') && (
                              <div style={{ marginBottom: 10 }}>
                                <div className='lists-outer-row'>
                                  <div className='shifts'>
                                    <strong>Manifest Status:</strong>{' '}
                                    {this.getManifestStatusLabel(
                                      this.state.manifestStatus,
                                    )}
                                    {(this.state.manifestStatus === 'inuse' ||
                                      this.state.manifestStatus ===
                                        'pending') &&
                                      permList.includes(
                                        'Status Change Resource',
                                      ) && (
                                        <span
                                          className='editor'
                                          title='Close Out'
                                          onClick={this.editManifestStatus}
                                        >
                                          <img
                                            src={
                                              require('../assets/images/edit.svg')
                                                .default
                                            }
                                          />
                                        </span>
                                      )}
                                  </div>
                                </div>
                              </div>
                            )}
                            {(this.state.currentAssignmentStatus ==
                              'Committed' ||
                              this.state.manifestStatus === 'pending') && (
                              <React.Fragment>
                                <p className='shifts'>
                                  <strong>Incident Name:</strong>{' '}
                                  {this.state.currentAssignmentDetails.name}
                                </p>

                                <div className='lists-outer-row'>
                                  <div className='shifts'>
                                    <strong>Total Shifts:</strong>{' '}
                                    {this.state.currentAssignmentDetails.shifts}
                                  </div>
                                  <div className='shifts'>
                                    <strong>Location:</strong>{' '}
                                    {
                                      this.state.currentAssignmentDetails
                                        .location
                                    }
                                  </div>
                                  <div className='shifts'>
                                    <strong>Complexity:</strong>{' '}
                                    {
                                      this.state.currentAssignmentDetails
                                        .complexity
                                    }
                                  </div>
                                  <div className='shifts'>
                                    <strong>Fuel Type:</strong>{' '}
                                    {
                                      this.state.currentAssignmentDetails
                                        .fuelType
                                    }
                                  </div>
                                  <div className='shifts'>
                                    <strong>Fire Size:</strong>{' '}
                                    {
                                      this.state.currentAssignmentDetails
                                        .fireSize
                                    }
                                  </div>
                                  <div className='shifts'>
                                    <strong>Hotline Shifts:</strong>{' '}
                                    {
                                      this.state.currentAssignmentDetails
                                        .hotlineShifts
                                    }
                                  </div>
                                  <div className='shifts'>
                                    <strong>Type Of Assignment:</strong>{' '}
                                    {
                                      this.state.currentAssignmentDetails
                                        .assignment_type
                                    }{' '}
                                  </div>
                                  <div className='shifts'>
                                    <strong>Date On:</strong>{' '}
                                    {formatDate(
                                      this.state.currentAssignmentDetails
                                        .date_on,
                                    )}
                                  </div>
                                  <div className='shifts'>
                                    <strong>Date Off:</strong>{' '}
                                    {formatDate(
                                      this.state.currentAssignmentDetails
                                        .date_off,
                                    )}
                                  </div>
                                </div>
                              </React.Fragment>
                            )}
                            {this.state.currentAssignmentStatus ==
                              'Unavailable' &&
                              crew_data && (
                                <React.Fragment>
                                  <p className='shifts'>
                                    <strong>Unavailable Reason:</strong>{' '}
                                    {crew_data.unavailable_reason}
                                  </p>
                                </React.Fragment>
                              )}
                            <p className='shifts'>
                              <strong>Notes:</strong>{' '}
                              {this.state.currentAssignmentDetails.notes}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='inv-sidemenu-box'>
                    <div className='change-stat-head'>
                      <h5>
                        {this.state.editMode
                          ? 'Edit Assignment History'
                          : 'Change Status'}
                      </h5>
                    </div>
                    <div
                      className={`change-status-pop ${
                        this.state.preventAssignmentPopupClick ? 'disabled' : ''
                      }`}
                    >
                      <form
                        onSubmit={this.saveAssignmentChanges}
                        id='assignment-status-form'
                      >
                        {/* Manifest Status In Use - Close Out */}
                        {this.state.manifestStatus === 'inuse' &&
                          this.state.isManifestCloseOut && (
                            <React.Fragment>
                              <div className='form-group'>
                                <label htmlFor='manifestCloseOutStatus'>
                                  Select Status *
                                </label>
                                <select
                                  className='form-control'
                                  id='manifestCloseOutStatus'
                                  value='Closed Out'
                                  disabled
                                  required
                                >
                                  <option value='Closed Out'>Closed Out</option>
                                </select>
                              </div>

                              <div className='form-group'>
                                <label htmlFor='manifestCloseOutDateOff'>
                                  Date Off *
                                </label>
                                <span className='date-outer'>
                                  <span
                                    onClick={() => {
                                      this.refs.manifestCloseOutDateOff.setFocus();
                                    }}
                                    className='datepicker-image'
                                  >
                                    <img
                                      src={
                                        require('../assets/images/icon_calendar.svg')
                                          .default
                                      }
                                    />
                                  </span>
                                  <DatePicker
                                    className='txt'
                                    ref='manifestCloseOutDateOff'
                                    id='manifestCloseOutDateOff'
                                    name='manifestCloseOutDateOff'
                                    selected={
                                      this.state.manifestCloseOutDateOff
                                    }
                                    onChange={(date) =>
                                      this.setState({
                                        manifestCloseOutDateOff: date,
                                      })
                                    }
                                    minDate={
                                      this.state.latestAssignmentHistory &&
                                      this.state.latestAssignmentHistory
                                        .incident_projects?.date_on
                                        ? moment(
                                            this.state.latestAssignmentHistory
                                              .incident_projects.date_on,
                                          )
                                        : null
                                    }
                                    maxDate={moment()}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode='select'
                                    placeholderText='Select Date'
                                    required
                                    onKeyDown={(e) => e.preventDefault()}
                                  />
                                </span>
                              </div>

                              <div className='form-group name-list-wrapper'>
                                <label htmlFor='manifestCloseOutHotlineShifts'>
                                  Hotline Shifts *
                                </label>
                                <input
                                  ref='manifestCloseOutHotlineShifts'
                                  name='manifestCloseOutHotlineShifts'
                                  value={
                                    this.state.manifestCloseOutHotlineShifts
                                  }
                                  onChange={this.handleChange}
                                  className='form-control'
                                  required
                                  type='number'
                                  min={0}
                                  onWheel={this.handleOnWheel}
                                  onKeyDown={preventNegativeValueInDocs}
                                />
                              </div>

                              <div className='form-group'>
                                <label htmlFor='manifestCloseOutNotes'>
                                  Notes
                                </label>
                                <textarea
                                  ref='manifestCloseOutNotes'
                                  name='manifestCloseOutNotes'
                                  value={this.state.manifestCloseOutNotes}
                                  onChange={this.handleChange}
                                  className='form-control'
                                  rows='3'
                                ></textarea>
                              </div>
                            </React.Fragment>
                          )}

                        {/* Manifest Status Pending - Commit Form */}
                        {this.state.manifestStatus === 'pending' &&
                          this.state.isManifestCloseOut && (
                            <React.Fragment>
                              <div className='form-group'>
                                <label htmlFor='manifestCommitStatus'>
                                  Select Status *
                                </label>
                                <select
                                  className='form-control'
                                  id='manifestCommitStatus'
                                  value='In Use'
                                  disabled
                                  required
                                >
                                  <option value='In Use'>In Use</option>
                                </select>
                              </div>

                              <div className='form-group'>
                                <label htmlFor='exampleFormControlInput1'>
                                  Type of Assignment *
                                </label>
                                <select
                                  className='form-control'
                                  name='tempAssignmentType'
                                  value={this.state.tempAssignmentType}
                                  ref='AssignmentType'
                                  onChange={this.handleSelect}
                                  required
                                >
                                  <option value=''>Type of Assignment</option>
                                  {this.state.assigmentCategoryOptions.map(
                                    (item, index) => (
                                      <option key={index} value={item.id}>
                                        {item.value}
                                      </option>
                                    ),
                                  )}
                                </select>
                              </div>

                              <AllManifest
                                resourceId={this.state.id}
                                onSelect={(manifestId) => {
                                  this.setState({
                                    fireHistoryManifestId: manifestId,
                                  });
                                }}
                                setIncident={(incident) => {
                                  this.setState({ projectName: incident });
                                }}
                              />

                              <div className='form-group name-list-wrapper'>
                                <label htmlFor='exampleFormControlInput1'>
                                  Incident Name *
                                </label>
                                <input
                                  required
                                  ref='ProjectName'
                                  name='projectName'
                                  value={this.state.projectName}
                                  onChange={this.handleChange}
                                  type='text'
                                  className='form-control'
                                  disabled
                                  readOnly
                                />
                              </div>
                              <div className='form-group name-list-wrapper'>
                                <label htmlFor='exampleFormControlInput1'>
                                  Location
                                </label>
                                <input
                                  ref='Location'
                                  name='location'
                                  value={this.state.location}
                                  onChange={this.handleChange}
                                  type='text'
                                  className='form-control'
                                />
                              </div>
                              <div className='form-group'>
                                <label htmlFor='exampleFormControlInput1'>
                                  Complexity
                                </label>
                                <select
                                  className='form-control'
                                  id='exampleFormControlSelect1'
                                  name='complexity'
                                  value={this.state.complexity}
                                  onChange={this.handleChange}
                                >
                                  <option value=''>
                                    Choose Complexity Level
                                  </option>

                                  {complexity.map((item, index) => (
                                    <option key={index} value={item.value}>
                                      {item.value}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className='form-group'>
                                <label htmlFor='exampleFormControlInput1'>
                                  Fuel Type
                                </label>
                                <select
                                  className='form-control'
                                  id='exampleFormControlSelect1'
                                  name='fuel_type'
                                  value={this.state.fuel_type}
                                  onChange={this.handleChange}
                                >
                                  <option value=''>Choose Fuel Type</option>

                                  {fuelType.map((item, index) => (
                                    <option key={index} value={item.value}>
                                      {item.value}- {item.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className='form-group'>
                                <label htmlFor='exampleFormControlInput1'>
                                  Fire Size
                                </label>
                                <select
                                  className='form-control'
                                  id='exampleFormControlSelect1'
                                  name='fire_size'
                                  value={this.state.fire_size}
                                  onChange={this.handleChange}
                                >
                                  <option value=''>Choose Fire Size</option>

                                  {fireSize.map((item, index) => (
                                    <option key={index} value={item.value}>
                                      {item.value}- {item.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className='form-group'>
                                <label htmlFor='exampleFormControlInput1'>
                                  Date On
                                </label>
                                <span className='date-outer'>
                                  <span
                                    onClick={() => {
                                      this.refs.dateon.setFocus();
                                    }}
                                    className='datepicker-image'
                                  >
                                    <img
                                      src={
                                        require('../assets/images/icon_calendar.svg')
                                          .default
                                      }
                                    />
                                  </span>
                                  <DatePicker
                                    className='txt '
                                    ref='dateon'
                                    id='Dateon'
                                    name='Dateon'
                                    selected={this.state.onDate}
                                    onChange={(date) => {
                                      this.setState({ onDate: date }, () => {
                                        this.renderTotalShifts(
                                          this.state.onDate,
                                          this.state.offDate,
                                        );
                                      });
                                    }}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode='select'
                                    placeholderText='Select Date'
                                    onKeyDown={(e) => e.preventDefault()}
                                  />
                                </span>
                              </div>
                              <div className='form-group'>
                                <label htmlFor='exampleFormControlInput1'>
                                  Notes
                                </label>
                                <textarea
                                  ref='note'
                                  name='projectNote'
                                  value={this.state.projectNote}
                                  onChange={this.handleChange}
                                  className='form-control'
                                  rows='3'
                                ></textarea>
                              </div>
                            </React.Fragment>
                          )}

                        {/* Regular Assignment Status Fields - Only show when NOT manifest close out/commit */}
                        {!(
                          (this.state.manifestStatus === 'inuse' &&
                            this.state.isManifestCloseOut) ||
                          (this.state.manifestStatus === 'pending' &&
                            this.state.isManifestCloseOut)
                        ) && (
                          <React.Fragment>
                            <div className='form-group'>
                              <label htmlFor='exampleFormControlInput1'>
                                Select Status *
                              </label>
                              <select
                                className='form-control'
                                id='exampleFormControlSelect1'
                                value={
                                  this.state.editMode
                                    ? this.state.currentAssignmentStatus
                                    : this.state.tempAssignmentStatus
                                }
                                onChange={this.handleAssignmentChange}
                                disabled={this.state.editMode}
                                required
                              >
                                {!this.state.editMode &&
                                  assignmentStatuses
                                    .filter(
                                      (status) =>
                                        status.value !==
                                        this.state.currentAssignmentStatus,
                                    )
                                    .map((status) => (
                                      <option
                                        key={status.value}
                                        value={status.value}
                                      >
                                        {status.label}
                                      </option>
                                    ))}
                                {this.state.editMode && (
                                  <option
                                    value={this.state.currentAssignmentStatus}
                                  >
                                    {this.state.currentAssignmentStatus ||
                                      'Assignment Status'}
                                  </option>
                                )}
                              </select>
                            </div>

                            {/* Committed */}
                            {this.state.tempAssignmentStatus == 'Committed' && (
                              <React.Fragment>
                                <div className='form-group'>
                                  <label htmlFor='exampleFormControlInput1'>
                                    Type of Assignment *
                                  </label>
                                  <select
                                    className='form-control'
                                    name='tempAssignmentType'
                                    value={this.state.tempAssignmentType}
                                    ref='AssignmentType'
                                    onChange={this.handleSelect}
                                    required
                                  >
                                    <option value=''>Type of Assignment</option>
                                    {this.state.assigmentCategoryOptions.map(
                                      (item, index) => (
                                        <option key={index} value={item.id}>
                                          {item.value}
                                        </option>
                                      ),
                                    )}
                                  </select>
                                </div>

                                {/* Select Existing Project */}

                                {/* Manifest Selection "Select Manifest" */}
                                {!this.state.editMode && (
                                  <AllManifest
                                    resourceId={this.state.id}
                                    onSelect={(manifestId) => {
                                      this.setState({
                                        typeSlug: manifestId
                                          ? FIRE_HISTORY_TYPE_SLUG?.WITH_MANIFEST
                                          : null,
                                        fireHistoryManifestId: manifestId,
                                      });
                                    }}
                                    setIncident={(incident) => {
                                      this.setState({ projectName: incident });
                                    }}
                                  />
                                )}
                                {/* End */}
                                {(this.state.projectId == null ||
                                  (this.state.editMode == true &&
                                    this.state.initialStatusId == 3)) && (
                                  <div>
                                    <div className='form-group name-list-wrapper'>
                                      <label htmlFor='exampleFormControlInput1'>
                                        Incident Name *
                                      </label>
                                      <input
                                        required
                                        ref='ProjectName'
                                        name='projectName'
                                        value={this.state.projectName}
                                        onChange={this.handleChange}
                                        type='text'
                                        className='form-control'
                                        disabled
                                        readOnly
                                      />
                                    </div>
                                    <div className='form-group name-list-wrapper'>
                                      <label htmlFor='exampleFormControlInput1'>
                                        Location{' '}
                                      </label>
                                      <input
                                        ref='Location'
                                        name='location'
                                        value={this.state.location}
                                        onChange={this.handleChange}
                                        type='text'
                                        className='form-control'
                                      />
                                    </div>
                                    <div className='form-group'>
                                      <label htmlFor='exampleFormControlInput1'>
                                        Complexity
                                      </label>
                                      <select
                                        className='form-control'
                                        id='exampleFormControlSelect1'
                                        name='complexity'
                                        value={this.state.complexity}
                                        onChange={this.handleChange}
                                      >
                                        <option value=''>
                                          Choose Complexity Level
                                        </option>

                                        {complexity.map((item, index) => (
                                          <option
                                            key={index}
                                            value={item.value}
                                          >
                                            {item.value}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    <div className='form-group'>
                                      <label htmlFor='exampleFormControlInput1'>
                                        Fuel Type
                                      </label>
                                      <select
                                        className='form-control'
                                        id='exampleFormControlSelect1'
                                        name='fuel_type'
                                        value={this.state.fuel_type}
                                        onChange={this.handleChange}
                                      >
                                        <option value=''>
                                          Choose Fuel Type
                                        </option>

                                        {fuelType.map((item, index) => (
                                          <option
                                            key={index}
                                            value={item.value}
                                          >
                                            {item.value}- {item.label}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    <div className='form-group'>
                                      <label htmlFor='exampleFormControlInput1'>
                                        Fire Size
                                      </label>
                                      <select
                                        className='form-control'
                                        id='exampleFormControlSelect1'
                                        name='fire_size'
                                        value={this.state.fire_size}
                                        onChange={this.handleChange}
                                      >
                                        <option value=''>
                                          Choose Fire Size
                                        </option>

                                        {fireSize.map((item, index) => (
                                          <option
                                            key={index}
                                            value={item.value}
                                          >
                                            {item.value}- {item.label}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    <div className='form-group'>
                                      <label htmlFor='exampleFormControlInput1'>
                                        Date On
                                      </label>
                                      <span className='date-outer'>
                                        <span
                                          onClick={() => {
                                            this.refs.dateon.setFocus();
                                          }}
                                          className='datepicker-image'
                                        >
                                          <img
                                            src={
                                              require('../assets/images/icon_calendar.svg')
                                                .default
                                            }
                                          />
                                        </span>
                                        <DatePicker
                                          className='txt '
                                          ref='dateon'
                                          id='Dateon'
                                          name='Dateon'
                                          selected={this.state.onDate}
                                          onChange={(date) => {
                                            this.setState(
                                              { onDate: date },
                                              () => {
                                                if (
                                                  this.state.editMode &&
                                                  permList.includes(
                                                    'Edit Assignment History',
                                                  )
                                                ) {
                                                  this.renderTotalShifts(
                                                    this.state.onDate,
                                                    this.state.offDate,
                                                  );
                                                }
                                              },
                                            );
                                          }}
                                          showMonthDropdown
                                          showYearDropdown
                                          dropdownMode='select'
                                          placeholderText='Select Date'
                                          onKeyDown={(e) => e.preventDefault()}
                                        />
                                      </span>
                                    </div>
                                    {this.state.editMode &&
                                      permList.includes(
                                        'Edit Assignment History',
                                      ) && (
                                        <>
                                          <div className='form-group'>
                                            <label htmlFor='exampleFormControlInput1'>
                                              Date Off{' '}
                                              {this.state.offDate ? '*' : ''}
                                            </label>
                                            <span className='date-outer'>
                                              <span
                                                onClick={() => {
                                                  this.refs.dateoff.setFocus();
                                                }}
                                                className='datepicker-image'
                                              >
                                                <img
                                                  src={
                                                    require('../assets/images/icon_calendar.svg')
                                                      .default
                                                  }
                                                />
                                              </span>
                                              <DatePicker
                                                className='txt '
                                                ref='dateoff'
                                                id='Dateoff'
                                                name='assignDate'
                                                selected={this.state.offDate}
                                                onChange={(date) => {
                                                  this.setState(
                                                    { offDate: date },
                                                    () => {
                                                      this.renderTotalShifts(
                                                        this.state.onDate,
                                                        this.state.offDate,
                                                      );
                                                    },
                                                  );
                                                }}
                                                minDate={this.state.onDate}
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode='select'
                                                placeholderText='Select Date'
                                                onKeyDown={(e) =>
                                                  e.preventDefault()
                                                }
                                              />
                                            </span>
                                          </div>
                                          <div className='form-group name-list-wrapper'>
                                            <label htmlFor='exampleFormControlInput1'>
                                              Hotline Shifts{' '}
                                            </label>
                                            <input
                                              ref='Location'
                                              name='hotline_shifts'
                                              value={this.state.hotline_shifts}
                                              onChange={this.handleChange}
                                              className='form-control'
                                              type='number'
                                              min={0}
                                              onWheel={this.handleOnWheel}
                                              onKeyDown={
                                                preventNegativeValueInDocs
                                              }
                                            />
                                          </div>
                                          <div className='form-group'>
                                            <label htmlFor='exampleFormControlInput1'>
                                              Total Shifts
                                            </label>
                                            <input
                                              type='number'
                                              name='projectShift'
                                              value={this.state.projectShift}
                                              disabled
                                              ref='totalShifts'
                                              className='form-control'
                                            />
                                          </div>
                                        </>
                                      )}
                                  </div>
                                )}
                              </React.Fragment>
                            )}

                            {/* Unavailable */}
                            {this.state.tempAssignmentStatus ===
                              'Unavailable' && (
                              <React.Fragment>
                                <div className='form-group'>
                                  <label htmlFor='unavailable_reason'>
                                    Unavailable Reason *
                                  </label>
                                  <select
                                    className='form-control'
                                    id='unavailable_reason_id'
                                    name='unavailable_reason_id'
                                    value={this.state.unavailable_reason_id}
                                    onChange={this.handleChange}
                                    required
                                  >
                                    <option value=''>-no reason-</option>
                                    {this.state.unavailable_reasons.map(
                                      (reason) => {
                                        return (
                                          <option
                                            value={reason.id}
                                            key={reason.id}
                                          >
                                            {reason.value}
                                          </option>
                                        );
                                      },
                                    )}
                                  </select>
                                </div>
                                <div className='form-group'>
                                  <label htmlFor='exampleFormControlInput1'>
                                    Unavailable Start Date *
                                  </label>
                                  <span className='date-outer'>
                                    <DatePicker
                                      className='txt'
                                      ref='unavailable_start_date'
                                      id='unavailable_start_date'
                                      name='unavailable_start_date'
                                      selected={
                                        this.state.unavailable_start_date
                                      }
                                      onChange={(date) =>
                                        this.setState({
                                          unavailable_start_date: date,
                                        })
                                      }
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode='select'
                                      placeholderText='Select Date'
                                      required
                                      disabled
                                      onKeyDown={(e) => e.preventDefault()}
                                    />
                                  </span>
                                </div>

                                <div className='form-group'>
                                  <label htmlFor='exampleFormControlInput1'>
                                    Unavailable End Date *
                                  </label>
                                  <span className='date-outer'>
                                    <span
                                      onClick={() => {
                                        this.refs.unavailable_end_date.setFocus();
                                      }}
                                      className='datepicker-image'
                                    >
                                      <img
                                        src={
                                          require('../assets/images/icon_calendar.svg')
                                            .default
                                        }
                                      />
                                    </span>
                                    <DatePicker
                                      className='txt'
                                      ref='unavailable_end_date'
                                      id='unavailable_end_date'
                                      name='unavailable_end_date'
                                      selected={this.state.unavailable_end_date}
                                      onChange={(date) =>
                                        this.setState({
                                          unavailable_end_date: date,
                                        })
                                      }
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode='select'
                                      placeholderText='Select Date'
                                      required
                                      onKeyDown={(e) => e.preventDefault()}
                                      minDate={moment()}
                                    />
                                  </span>
                                </div>
                                {this.state.editMode &&
                                  permList.includes(
                                    'Edit Assignment History',
                                  ) && (
                                    <>
                                      <div className='form-group'>
                                        <label htmlFor='exampleFormControlInput1'>
                                          Unavailable End Date{' '}
                                          {this.state.unavailable_end_date
                                            ? '*'
                                            : ''}
                                        </label>
                                        <span className='date-outer'>
                                          <span
                                            onClick={() => {
                                              this.refs.unavailable_end_date.setFocus();
                                            }}
                                            className='datepicker-image'
                                          >
                                            <img
                                              src={
                                                require('../assets/images/icon_calendar.svg')
                                                  .default
                                              }
                                            />
                                          </span>
                                          <DatePicker
                                            className='txt'
                                            ref='unavailable_end_date'
                                            id='unavailable_end_date'
                                            name='unavailable_end_date'
                                            selected={
                                              this.state.unavailable_end_date
                                            }
                                            onChange={(date) =>
                                              this.setState({
                                                unavailable_end_date: date,
                                              })
                                            }
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode='select'
                                            placeholderText='Select Date'
                                            minDate={
                                              this.state.unavailable_start_date
                                                ? moment(
                                                    this.state
                                                      .unavailable_start_date,
                                                  )
                                                : null
                                            }
                                            onKeyDown={(e) =>
                                              e.preventDefault()
                                            }
                                          />
                                        </span>
                                      </div>
                                    </>
                                  )}
                              </React.Fragment>
                            )}

                            {this.state.currentAssignmentStatus ==
                              'Unavailable' &&
                              this.state.editMode == false && (
                                <div className='form-group'>
                                  <label htmlFor='exampleFormControlInput1'>
                                    Unavailable End Date *
                                  </label>
                                  <span className='date-outer'>
                                    <span
                                      onClick={() => {
                                        this.refs.unavailable_end_date.setFocus();
                                      }}
                                      className='datepicker-image'
                                    >
                                      <img
                                        src={
                                          require('../assets/images/icon_calendar.svg')
                                            .default
                                        }
                                      />
                                    </span>
                                    <DatePicker
                                      className='txt'
                                      ref='unavailable_end_date'
                                      id='unavailable_end_date'
                                      name='unavailable_end_date'
                                      selected={this.state.unavailable_end_date}
                                      onChange={(date) =>
                                        this.setState({
                                          unavailable_end_date: date,
                                        })
                                      }
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode='select'
                                      placeholderText='Select Date'
                                      minDate={
                                        this.state.latestAssignmentHistory &&
                                        this.state.latestAssignmentHistory
                                          .resource_unavailability?.start_date
                                          ? moment(
                                              this.state.latestAssignmentHistory
                                                .resource_unavailability
                                                ?.start_date,
                                            )
                                          : null
                                      }
                                      onKeyDown={(e) => e.preventDefault()}
                                    />
                                  </span>
                                </div>
                              )}
                            {this.state.currentAssignmentStatus ==
                              'Committed' &&
                              this.state.editMode == false && (
                                <>
                                  <div className='form-group'>
                                    <label htmlFor='exampleFormControlInput1'>
                                      Date Off *
                                    </label>
                                    <span className='date-outer'>
                                      <span
                                        onClick={() => {
                                          this.refs.dateoff.setFocus();
                                        }}
                                        className='datepicker-image'
                                      >
                                        <img
                                          src={
                                            require('../assets/images/icon_calendar.svg')
                                              .default
                                          }
                                        />
                                      </span>
                                      <DatePicker
                                        className='txt'
                                        ref='dateoff'
                                        id='Dateoff'
                                        name='assignDate'
                                        selected={this.state.offDate}
                                        onChange={(date) =>
                                          this.setState({ offDate: date })
                                        }
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode='select'
                                        placeholderText='Select Date'
                                        minDate={
                                          this.state.latestAssignmentHistory &&
                                          this.state.latestAssignmentHistory
                                            .incident_projects?.date_on
                                            ? moment(
                                                this.state
                                                  .latestAssignmentHistory
                                                  .incident_projects.date_on,
                                              )
                                            : null
                                        }
                                        onKeyDown={(e) => e.preventDefault()}
                                      />
                                    </span>
                                  </div>
                                  <div className='form-group name-list-wrapper'>
                                    <label htmlFor='exampleFormControlInput1'>
                                      Hotline Shifts *
                                    </label>
                                    <input
                                      ref='Location'
                                      name='hotline_shifts'
                                      value={this.state.hotline_shifts}
                                      onChange={this.handleChange}
                                      className='form-control'
                                      required
                                      type='number'
                                      min={0}
                                      onWheel={this.handleOnWheel}
                                      onKeyDown={preventNegativeValueInDocs}
                                    />
                                  </div>
                                </>
                              )}
                            {(this.state.projectId == null ||
                              this.state.editMode == true) && (
                              <div className='form-group'>
                                <label htmlFor='exampleFormControlTextarea1'>
                                  Notes
                                </label>
                                <textarea
                                  ref='note'
                                  name='projectNote'
                                  value={this.state.projectNote}
                                  onChange={this.handleChange}
                                  className='form-control'
                                  rows='3'
                                ></textarea>
                              </div>
                            )}

                            {/* Available */}
                            {this.state.tempAssignmentStatus === 'Available' &&
                              this.state.currentAssignmentStatus !==
                                'Unavailable' && (
                                <React.Fragment>
                                  <div className='form-group'>
                                    <label htmlFor='exampleFormControlInput1'>
                                      Unavailable End Date *
                                    </label>
                                    <span className='date-outer'>
                                      <span
                                        onClick={() => {
                                          this.refs.unavailable_end_date.setFocus();
                                        }}
                                        className='datepicker-image'
                                      >
                                        <img
                                          src={
                                            require('../assets/images/icon_calendar.svg')
                                              .default
                                          }
                                        />
                                      </span>
                                      <DatePicker
                                        className='txt'
                                        ref='unavailable_end_date'
                                        id='unavailable_end_date'
                                        name='unavailable_end_date'
                                        selected={
                                          this.state.unavailable_end_date
                                        }
                                        onChange={(date) =>
                                          this.setState({
                                            unavailable_end_date: date,
                                          })
                                        }
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode='select'
                                        placeholderText='Select Date'
                                        required
                                        onKeyDown={(e) => e.preventDefault()}
                                        minDate={moment()}
                                      />
                                    </span>
                                  </div>
                                </React.Fragment>
                              )}
                          </React.Fragment>
                        )}

                        <div className='submit-area' style={{ marginTop: 15 }}>
                          <button type='submit' className='btn btn-primary'>
                            Submit
                          </button>
                          <button
                            onClick={(event) => {
                              this.closeStatusPopup();
                              event.preventDefault();
                            }}
                            className='btn btn-primary cancel'
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>

                  {permList.includes('List Resource Manifests') && (
                    <div ref={this.manifestTableRef}>
                      <Accordian
                        title='Manifest'
                        persistKey='resource-accordion-manifest'
                      >
                        <div className='resource_accordion_wrapper'>
                          <div className='mobile_hide'>
                            <div className='manifest_list outer_list your-crew-manifest'>
                              <div className='list_header'>
                                <div className='list_item_head'>
                                  Contract Type
                                </div>
                                <div className='list_item_head'>
                                  Contract Number
                                </div>
                                <div className='list_item_head'>
                                  Incident Name
                                </div>
                                <div className='list_item_head'>
                                  Resource Number
                                </div>
                                <div className='list_item_head'>RO</div>
                                <div className='list_item_head'>Date Added</div>
                                <div className='list_item_head'>
                                  Date Assigned
                                </div>
                                <div className='list_item_head' />
                              </div>
                              {manifestsOption.length > 0 ? (
                                manifestsOption
                              ) : (
                                <div
                                  className='applicant_item'
                                  key='noManifests'
                                >
                                  <p>No Manifest added!</p>
                                </div>
                              )}
                              {paginationHtml}
                            </div>
                          </div>
                          {/* Mobile view - same structure as desktop */}
                          {(() => {
                            const manifestData = this.state.ManifestListV1;

                            if (!manifestData || manifestData.length === 0) {
                              return null;
                            }

                            // Group manifests by their core details (same as desktop)
                            const groupedManifests = manifestData.reduce(
                              (groups, item) => {
                                const key = `${item.manifest_id}_${item.abbreviation}_${item.contract_number}_${item.incident_name}_${item.resource_name}`;
                                if (!groups[key]) {
                                  groups[key] = {
                                    manifestId: item.manifest_id || item.mid,
                                    abbreviation: item.abbreviation || '',
                                    contractNumber: item.contract_number || '-',
                                    incidentName: item.incident_name || '',
                                    resourceNumber: item.resource_number || '',
                                    addedDate: item.added_date || '',
                                    dateAssigned: item.date_assigned || '',
                                    resourceOrderFormExists:
                                      item.resource_order_form_exists,
                                    resourceOrderName: item.resource_order_name,
                                    assignmentStatus: item.assignment_status,
                                    manifestAvailability:
                                      item.manifest_availability,
                                    baseManifestId:
                                      item.bid || item.base_manifest_id,
                                    versions: [],
                                  };
                                }

                                if (item.versions && item.versions.length > 0) {
                                  groups[key].versions.push(...item.versions);
                                }

                                return groups;
                              },
                              {},
                            );

                            // Sort by latest version date
                            const sortedManifests = Object.values(
                              groupedManifests,
                            ).sort((a, b) => {
                              const aLatestVersion =
                                a.versions.find((v) => v.latest_version) ||
                                a.versions[0];
                              const bLatestVersion =
                                b.versions.find((v) => v.latest_version) ||
                                b.versions[0];

                              if (!aLatestVersion && !bLatestVersion) return 0;
                              if (!aLatestVersion) return 1;
                              if (!bLatestVersion) return -1;

                              return (
                                new Date(bLatestVersion.added_date) -
                                new Date(aLatestVersion.added_date)
                              );
                            });

                            return sortedManifests.map((manifest, index) => {
                              const sortedVersions = manifest.versions.sort(
                                (a, b) => {
                                  return (
                                    new Date(b.added_date) -
                                    new Date(a.added_date)
                                  );
                                },
                              );
                              const hasMultipleVersions =
                                sortedVersions.length > 1;

                              return (
                                <React.Fragment key={index}>
                                  <hr />
                                  <CustomToolTip
                                    label={this.getStatusLabel(
                                      manifest.manifestAvailability,
                                    )}
                                    customClass={'fs-tooltip'}
                                  >
                                    <div className='for_mobile_manifest_list'>
                                      <div
                                        className={`manifest_items manifest-status-${this.getStatusClass(
                                          manifest.manifestAvailability,
                                        )}`}
                                      >
                                        <div className='status_item'>
                                          <div className='list_item'>
                                            <strong>Contract Type</strong>
                                          </div>
                                          <div className='list_item'>
                                            {manifest.abbreviation || '-'}
                                          </div>
                                        </div>
                                        <div className='status_item'>
                                          <div className='list_item'>
                                            <strong>Contract Number</strong>
                                          </div>
                                          <div className='list_item'>
                                            {manifest.contractNumber || '-'}
                                          </div>
                                        </div>
                                        <div className='status_item'>
                                          <div className='list_item'>
                                            <strong>Incident Name</strong>
                                          </div>
                                          <div className='list_item'>
                                            {manifest.incidentName || '-'}
                                          </div>
                                        </div>
                                        <div className='status_item'>
                                          <div className='list_item'>
                                            <strong>Resource Number</strong>
                                          </div>
                                          <div className='list_item'>
                                            {manifest.resourceNumber || '-'}
                                          </div>
                                        </div>
                                        <div className='status_item'>
                                          <div className='list_item'>
                                            <strong>RO</strong>
                                          </div>
                                          <div className='list_item'>
                                            {manifest.resourceOrderName || '-'}
                                          </div>
                                        </div>
                                        <div className='status_item'>
                                          <div className='list_item'>
                                            <strong>Date Added</strong>
                                          </div>
                                          <div className='list_item'>
                                            {manifest.addedDate
                                              ? formatDate(manifest.addedDate)
                                              : '-'}
                                          </div>
                                        </div>
                                        <div className='status_item'>
                                          <div className='list_item'>
                                            <strong>Date Assigned</strong>
                                          </div>
                                          <div className='list_item'>
                                            {manifest.dateAssigned
                                              ? formatDate(
                                                  manifest.dateAssigned,
                                                )
                                              : '-'}
                                          </div>
                                        </div>
                                        {hasMultipleVersions && (
                                          <div className='status_item'>
                                            <div className='list_item'>
                                              <strong>History</strong>
                                            </div>
                                            <div className='list_item'>
                                              <img
                                                src={
                                                  require('../assets/icons/history_24dp.svg')
                                                    .default
                                                }
                                                alt='View manifest'
                                                className='manifest-history-icon'
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                  console.log(
                                                    'View manifest history:',
                                                    manifest.manifestId,
                                                  );
                                                }}
                                              />
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </CustomToolTip>
                                </React.Fragment>
                              );
                            });
                          })()}
                          <div className='for_mobile_manifest_list'>
                            {paginationHtml}
                          </div>
                        </div>
                      </Accordian>
                    </div>
                  )}

                  {
                    <Accordian
                      title='History'
                      persistKey='my_crew_inventory_list'
                    >
                      <div className='resource_accordion_wrapper'>
                        <div className='history_lists outer_list '>
                          <div className='mobile_hide'>
                            <div className='list_header'>
                              {/* Status - Type of assignment - Project name - Location - complexity - fuel type - fire size - hotline - dates */}
                              <div className='list_item_head'>
                                Type of Assignment
                              </div>
                              <div className='list_item_head'>
                                Incident Name
                              </div>
                              <div className='list_item_head'>Location</div>
                              <div className='list_item_head'>Complexity</div>
                              <div className='list_item_head'>Fuel Type</div>
                              <div className='list_item_head'>Fire Size</div>
                              <div className='list_item_head'>
                                Hotline Shifts
                              </div>
                              <div className='list_item_head'>Date On</div>
                              <div className='list_item_head'>Date Off</div>

                              <div className='list_item_head list_item_head_trash'></div>
                              <div className='list_item_head list_item_head_trash'></div>
                              <div className='list_item_head list_item_head_trash'></div>
                            </div>
                            <div className='history_items'>
                              {this.state.assigmentStatusHistory?.data?.length >
                              0 ? (
                                this.state.assigmentStatusHistory.data.map(
                                  (item, index) => (
                                    <div
                                      className='status_item resource_history'
                                      key={index}
                                    >
                                      <div className='list_item'>
                                        {item.incident_projects
                                          ? item.incident_projects
                                              .assignment_type
                                          : '-'}
                                      </div>
                                      <div className='list_item'>
                                        {item.incident_projects
                                          ? item.incident_projects.name
                                          : '-'}
                                      </div>
                                      <div className='list_item'>
                                        {item.incident_projects?.location
                                          ? item.incident_projects.location
                                          : '-'}
                                      </div>
                                      <div className='list_item'>
                                        {item.incident_projects?.complexity
                                          ? item.incident_projects.complexity
                                          : '-'}
                                      </div>
                                      <div className='list_item'>
                                        {item.incident_projects?.fuel_type
                                          ? item.incident_projects.fuel_type
                                          : '-'}
                                      </div>
                                      <div className='list_item'>
                                        {item.incident_projects?.fire_size
                                          ? item.incident_projects.fire_size
                                          : '-'}
                                      </div>
                                      <div className='list_item'>
                                        {item.incident_projects?.hotline_shifts
                                          ? item.incident_projects
                                              .hotline_shifts
                                          : '-'}
                                      </div>
                                      <div className='list_item'>
                                        {item.incident_projects
                                          ? formatDate(
                                              item.incident_projects.date_on,
                                            )
                                          : item.unavailable_start_date
                                            ? formatDate(
                                                item.unavailable_start_date,
                                              )
                                            : '-'}
                                      </div>
                                      <div className='list_item'>
                                        {item.incident_projects
                                          ? formatDate(
                                              item.incident_projects.date_off,
                                            )
                                          : item.unavailable_end_date
                                            ? formatDate(
                                                item.unavailable_end_date,
                                              )
                                            : '-'}
                                      </div>

                                      <div className='list_item list_item_trash'>
                                        <Link
                                          to={`/employee-fire-history/${item.id}`}
                                        >
                                          <img
                                            style={{
                                              display:
                                                item.status != 3 ? 'none' : '',
                                            }}
                                            src={
                                              require('../assets/images/person-black.svg')
                                                .default
                                            }
                                            alt='Person Icon'
                                          />
                                        </Link>
                                      </div>

                                      {permList.includes(
                                        'Edit Assignment History',
                                      ) && (
                                        <>
                                          <div className='list_item list_item_trash'>
                                            <a
                                              href='#'
                                              onClick={() => {
                                                this.editResourceHistory(item);
                                              }}
                                            >
                                              <img
                                                src={
                                                  require('../assets/images/edit-black.svg')
                                                    .default
                                                }
                                              />
                                            </a>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  ),
                                )
                              ) : (
                                <div className='status_item resource_history'>
                                  No data to display.
                                </div>
                              )}
                            </div>
                            {paginationHistoryHtml}
                          </div>
                        </div>
                        {this.state.assigmentStatusHistory.data.map(
                          (item, index) => (
                            <React.Fragment key={index}>
                              <hr></hr>
                              <div className='for_mobile_history_list'>
                                <div className='history_items'>
                                  <div className='status_item'>
                                    <div className='list_item'>
                                      <strong>Type of Assignment</strong>
                                    </div>
                                    <div className='list_item'>
                                      {item.incident_projects
                                        ? item.incident_projects.assignment_type
                                        : '-'}
                                    </div>
                                  </div>
                                  <div className='status_item'>
                                    <div className='list_item'>
                                      <strong>Incident Name</strong>
                                    </div>
                                    <div className='list_item'>
                                      {item.incident_projects
                                        ? item.incident_projects.name
                                        : '-'}
                                    </div>
                                  </div>
                                  <div className='status_item'>
                                    <div className='list_item'>
                                      <strong>Location</strong>
                                    </div>
                                    <div className='list_item'>
                                      {item.incident_projects?.location
                                        ? item.incident_projects.location
                                        : '-'}
                                    </div>
                                  </div>
                                  <div className='status_item'>
                                    <div className='list_item'>
                                      <strong>Complexity</strong>
                                    </div>
                                    <div className='list_item'>
                                      {item.incident_projects?.complexity
                                        ? item.incident_projects.complexity
                                        : '-'}
                                    </div>
                                  </div>
                                  <div className='status_item'>
                                    <div className='list_item'>
                                      <strong>Fuel Type</strong>
                                    </div>
                                    <div className='list_item'>
                                      {item.incident_projects?.fuel_type
                                        ? item.incident_projects.fuel_type
                                        : '-'}
                                    </div>
                                  </div>
                                  <div className='status_item'>
                                    <div className='list_item'>
                                      <strong>Fire Size</strong>
                                    </div>
                                    <div className='list_item'>
                                      {item.incident_projects?.fire_size
                                        ? item.incident_projects.fire_size
                                        : '-'}
                                    </div>
                                  </div>
                                  <div className='status_item'>
                                    <div className='list_item'>
                                      <strong>Hotline Shifts</strong>
                                    </div>
                                    <div className='list_item'>
                                      {item.incident_projects?.hotline_shifts
                                        ? item.incident_projects.hotline_shifts
                                        : '-'}
                                    </div>
                                  </div>
                                  <div className='status_item'>
                                    <div className='list_item'>
                                      <strong>Date On</strong>
                                    </div>
                                    <div className='list_item'>
                                      {item.incident_projects
                                        ? formatDate(
                                            item.incident_projects.date_on,
                                          )
                                        : item.unavailable_start_date
                                          ? formatDate(
                                              item.unavailable_start_date,
                                            )
                                          : '-'}
                                    </div>
                                  </div>
                                  <div className='status_item'>
                                    <div className='list_item'>
                                      <strong>Date Off</strong>
                                    </div>
                                    <div className='list_item'>
                                      {item.incident_projects
                                        ? formatDate(
                                            item.incident_projects.date_off,
                                          )
                                        : item.unavailable_end_date
                                          ? formatDate(
                                              item.unavailable_end_date,
                                            )
                                          : '-'}
                                    </div>
                                  </div>
                                  <div className='status_item'>
                                    <div className='list_item'>
                                      <div className='list_item list_item_trash'>
                                        <Link
                                          to={`/employee-fire-history/${item.id}`}
                                        >
                                          <img
                                            style={{
                                              display:
                                                item.status != 3 ? 'none' : '',
                                            }}
                                            src={
                                              require('../assets/images/person-black.svg')
                                                .default
                                            }
                                            alt='Person Icon'
                                          />
                                        </Link>
                                      </div>
                                    </div>

                                    {permList.includes(
                                      'Edit Assignment History',
                                    ) && (
                                      <>
                                        <div className='list_item'>
                                          <div className='list_item list_item_trash'>
                                            <a
                                              href='#'
                                              onClick={() => {
                                                this.editResourceHistory(item);
                                              }}
                                            >
                                              <img
                                                src={
                                                  require('../assets/images/edit-black.svg')
                                                    .default
                                                }
                                              />
                                            </a>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </React.Fragment>
                          ),
                        )}
                        <div className='for_mobile_history_list'>
                          {paginationHistoryHtml}
                        </div>
                      </div>
                    </Accordian>
                  }
                </React.Fragment>
              )}

              {permList.includes('Inventory') && (
                <Accordian
                  title='Inventory'
                  persistKey='resource_inventory_list'
                >
                  <div className='resource_accordion_wrapper'>
                    <div className='employee_list outer_list'>
                      <div className='list_header resource-view'>
                        <div className='list_item_head image-holder'>
                          Inventory
                        </div>
                        <div className='list_item_head'>Item Name</div>
                        <div className='list_item_head'>Cost</div>
                        <div className='list_item_head'>Assigned To</div>
                      </div>
                      {(Array.isArray(inventoryList) ? inventoryList : []).map(
                        (item, index) => {
                          return (
                            <div className='empployeeItem' key={index}>
                              <div className='emp_link_resource crew_wrapper resource_details bg-fill'>
                                <div className='employee_item '>
                                  <div className='list_item image-holder'>
                                    <span className='pos_counter'>
                                      {(inventoryPage - 1) * inventoryPerPage +
                                        index +
                                        1}
                                    </span>
                                    <img
                                      alt=''
                                      className={`${
                                        item.user?.hash ? 'Available' : ''
                                      }`}
                                      src={
                                        item.pic
                                          ? config.s3BucketUrl + '/' + item.pic
                                          : config.apiUrl + '/' + config.altImg
                                      }
                                      onError={this.onImageError.bind(this)}
                                    />
                                  </div>
                                  <div className='list_item item_width'>
                                    <Link
                                      className='link'
                                      to={`/inventory/inventory-view/${item.id}`}
                                    >
                                      {item.unique_id}
                                    </Link>
                                  </div>
                                  <div className='list_item item_width'>
                                    {item.cost || '--'}
                                  </div>
                                  <div className='list_item item_width'>
                                    {item.user ? (
                                      <Link
                                        className='link'
                                        to={`/resource-profile/${item.user.hash}/profile`}
                                      >
                                        {item.user.first_name +
                                          ' ' +
                                          item.user.last_name}
                                      </Link>
                                    ) : (
                                      '--'
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        },
                      )}
                      {this.inventoryPagination()}
                    </div>
                  </div>
                </Accordian>
              )}

              {permList.includes('Inventory') && (
                <div className='crew_inventory'>{this.state.stats_array}</div>
              )}

              {permList.includes('List Vehicles') && (
                <Accordian title='Vehicles' persistKey='my_crew_vehicles_list'>
                  <div className='vehicle_list outer_list'>
                    <div className=''>
                      <div className='list_header'>
                        <div className='list_item_head'>Unique Name</div>
                        <div className='list_item_head'>Driver</div>
                        <div className='list_item_head'>Driver License</div>
                        <div className='list_item_head appln_date'>
                          Vehicle Make/Model
                        </div>
                        <div className='list_item_head'>Vehicle License</div>
                      </div>
                      {vehiclesOption}
                    </div>
                  </div>
                </Accordian>
              )}

              <Accordian
                title='Employees Available'
                persistKey='my_crew_available_employee_list'
              >
                <EmployeeList
                  {...this.props}
                  permList={permList}
                  type='available'
                  className='available'
                  resourceId={this.state.id}
                  employeeList={availableEmployees}
                  startIndex={1}
                  profile={this.profile.bind(this)}
                  updateList={this.getEmployeeList.bind(this)}
                />
              </Accordian>

              <Accordian
                title='Pending Employees'
                persistKey='my_crew_guest_employee_list'
              >
                <EmployeeList
                  {...this.props}
                  className='pending'
                  type='guest'
                  permList={permList}
                  resourceId={this.state.id}
                  employeeList={pendingEmployees}
                  startIndex={availableEmployees.length + 1}
                  profile={this.profile.bind(this)}
                  updateList={this.getEmployeeList.bind(this)}
                />
              </Accordian>

              <Accordian
                title='Employees Locked'
                persistKey='my_crew_locked_employee_list'
              >
                <EmployeeList
                  {...this.props}
                  permList={permList}
                  className='locked'
                  type='locked'
                  resourceId={this.state.id}
                  employeeList={lockedEmployees}
                  startIndex={
                    pendingEmployees.length + availableEmployees.length + 1
                  }
                  profile={this.profile.bind(this)}
                  updateList={this.getEmployeeList.bind(this)}
                />
              </Accordian>

              {/* Deleted Fire History Accordion */}
              {/* {permList.includes('Edit Assignment History') && (
                <Accordian
                  title='Deleted Fire History'
                  persistKey='resource-accordion-deleted-fire-history'
                >
                  <div className='resource_accordion_wrapper'>
                    <div className='history_lists outer_list '>
                      <div className='list_header table-view'>
                        <div className='list_item_head'>Type of Assignment</div>
                        <div className='list_item_head'>Incident Name</div>
                        <div className='list_item_head'>Location</div>
                        <div className='list_item_head'>Complexity</div>
                        <div className='list_item_head'>Fuel Type</div>
                        <div className='list_item_head'>Fire Size</div>
                        <div className='list_item_head'>Hotline Shifts</div>
                        <div className='list_item_head'>Date On</div>
                        <div className='list_item_head'>Date Off</div>
                      </div>
                      <div className='history_items'>
                        {this.state.deletedManifestHistory?.data?.length > 0 ? (
                          this.state.deletedManifestHistory.data.map(
                            (item, index) => (
                              <React.Fragment key={index}>
                                <div className='status_item resource_history'>
                                  <div className='list_item'>
                                    {(() => {
                                      let status =
                                        item.resource
                                          ?.resource_availability_status;

                                      if (
                                        status &&
                                        typeof status === 'object' &&
                                        status.value
                                      ) {
                                        status = status.value;
                                      }

                                      if (!status) {
                                        status = item.resource_status;
                                      }

                                      if (
                                        !status &&
                                        item.status !== undefined
                                      ) {
                                        status =
                                          item.status === 1
                                            ? 'Available'
                                            : item.status === 2
                                              ? 'Unavailable'
                                              : item.status === 3
                                                ? 'Committed'
                                                : null;
                                      }

                                      return this.formatResourceAvailabilityStatus(
                                        status,
                                      );
                                    })()}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects
                                      ? item.incident_projects.name
                                      : '-'}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects?.location
                                      ? item.incident_projects.location
                                      : '-'}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects?.complexity
                                      ? item.incident_projects.complexity
                                      : '-'}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects?.fuel_type
                                      ? item.incident_projects.fuel_type
                                      : '-'}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects?.fire_size
                                      ? item.incident_projects.fire_size
                                      : '-'}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects?.hotline_shifts
                                      ? item.incident_projects.hotline_shifts
                                      : '-'}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects
                                      ? formatDate(
                                          item.incident_projects.date_on,
                                        )
                                      : item.unavailable_start_date
                                        ? formatDate(
                                            item.unavailable_start_date,
                                          )
                                        : '-'}
                                  </div>
                                  <div className='list_item'>
                                    {item.incident_projects
                                      ? formatDate(
                                          item.incident_projects.date_off,
                                        )
                                      : item.unavailable_end_date
                                        ? formatDate(item.unavailable_end_date)
                                        : '-'}
                                  </div>
                                </div>
                              </React.Fragment>
                            ),
                          )
                        ) : (
                          <div className='status_item resource_history'>
                            <p>No deleted fire history found!</p>
                          </div>
                        )}
                        <div className='for_mobile_history_list'>
                          {this.getDeletedHistoryPaginationHtml()}
                        </div>
                      </div>
                    </div>
                  </div>
                </Accordian>
              )} */}
            </div>
          </div>
          <ReactModal
            isOpen={this.state.deleteHistoryOpen}
            onClose={this.deleteHistoryCloseModal.bind(this)}
            overlayClassName='deletetPopup'
          >
            <div id='deletePopup'>
              <div className='modal-head'>
                <h4 className='modal-title'>Confirm</h4>
                <img
                  alt='close'
                  className='closeModal'
                  onClick={this.deleteHistoryCloseModal.bind(this)}
                  src={require('../assets/images/close_green.png').default}
                />
              </div>

              <div className='modal-body'>
                <div className='status_step step1'>
                  <label>
                    Are you sure you want to remove this history? Doing so will
                    affect the employees' fire records.
                  </label>
                  <br />
                  <div className='btn_list_popup'>
                    <button
                      className='button grey'
                      onClick={this.deleteHistoryCloseModal.bind(this)}
                    >
                      Cancel
                    </button>
                    <button className='button' onClick={this.deleteHistory}>
                      OK
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ReactModal>
          <ReactModal
            isOpen={this.state.displayEditAssignmentConfirmPopup}
            onClose={this.closeEditAssignmentConfirmPopup.bind(this)}
            overlayClassName='closeEditAssignmentPopup'
          >
            <div id='deletePopup'>
              <div className='modal-head'>
                <h4 className='modal-title'>
                  Confirm Edit of Assignment History
                </h4>
                <img
                  alt='close'
                  className='closeModal'
                  onClick={this.closeEditAssignmentConfirmPopup.bind(this)}
                  src={require('../assets/images/close_green.png').default}
                />
              </div>
              <div className='modal-body'>
                <div className='status_step step1'>
                  <label>
                    Please note that any changes to the Date On and Date Off
                    fields will impact the employees' fire history records.
                  </label>
                  <br />
                  <div className='btn_list_popup'>
                    <button
                      className='button grey'
                      onClick={this.closeEditAssignmentConfirmPopup.bind(this)}
                    >
                      Cancel
                    </button>
                    <button
                      className='button'
                      onClick={this.editAssignmentConfirmation.bind(this)}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ReactModal>
          <Modal
            isOpen={this?.state?.enableAssignEmployeeModal}
            className='SignatureModal fire_history_assign_modal'
            contentLabel='Example Modal'
          >
            <section>
              <div className='modal-header'>
                <p className='sign_close'>Action Required.</p>
                <div
                  className='close-btn'
                  onClick={() => this.handleAutoAssignModalClose()}
                >
                  <span>&times;</span>
                </div>
              </div>
              <hr />
              <div style={{ padding: '0px 15px' }}>
                <RadioButton
                  checked={
                    this?.state?.typeSlug ===
                    FIRE_HISTORY_TYPE_SLUG?.AUTO_ASSIGN_MANIFEST
                  }
                  value={FIRE_HISTORY_TYPE_SLUG?.AUTO_ASSIGN_MANIFEST}
                  onChange={(e) =>
                    this.setState({ typeSlug: e?.target?.value })
                  }
                  label={'Auto Assign Employees'}
                />
                <RadioButton
                  checked={
                    this?.state?.typeSlug ===
                    FIRE_HISTORY_TYPE_SLUG?.MANUAL_ASSIGN_MANIFEST
                  }
                  value={FIRE_HISTORY_TYPE_SLUG?.MANUAL_ASSIGN_MANIFEST}
                  onChange={(e) =>
                    this.setState({ typeSlug: e?.target?.value })
                  }
                  label={'Assign employees Manually'}
                />
                {this?.state?.typeSlug ===
                  FIRE_HISTORY_TYPE_SLUG?.MANUAL_ASSIGN_MANIFEST && (
                  <div>
                    <FireHistoryEmployeeAssignDragAndDrop
                      resourceId={this.state.id}
                      ref={this.sortYourCrewRef}
                    />
                  </div>
                )}
              </div>
              <div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'end',
                    padding: 20,
                  }}
                >
                  <button
                    onClick={(event) => {
                      this.handleAutoAssignModalClose();
                      event.preventDefault();
                    }}
                    className='btn  cancel'
                    style={{
                      marginRight: 5,
                      backgroundColor: '#f0f0f0',
                      color: '#202020',
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type='submit'
                    className='button green'
                    onClick={(e) => this.handleFireHistoryAssignModal(e)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </section>
          </Modal>
          <EmailManifestModal
            isOpen={this.state.emailManifestModalOpen}
            onClose={this.closeEmailManifestModal}
            dispatchMailList={this.state.dispatchMailList}
            mailList={this.state.mailList}
            searchList={this.state.searchList}
            hideSearch={this.state.hideSearch}
            mailSearchKeyword={this.state.mailSearchKeyword}
            validManifestMail={this.state.validManifestMail}
            onEmailChange={this.emailChangeFn}
            onAddEmail={this.addManifestEmail}
            onRemoveEmail={this.removeList}
            onRemoveDispatchEmail={this.removeDispatchList}
            onSendEmail={this.handleSendEmailManifest}
            emailLoader={this.state.commitManifestLoading}
            buttonText='Send Email'
          />
        </div>
      );
    }
    return (
      <div className='resource_container your_crew_div'>
        <div className='page_title float'>
          <h1>{this.state.resource_name}</h1>
        </div>

        <div className='applicants_inner_head crew_outer inner_container'>
          <div className='inner_head'></div>
          <center
            id='feedLoader'
            className={this.state.loader ? this.state.loader : ''}
          >
            <img
              alt='Loader'
              src={require('../assets/images/loader.gif').default}
            />
          </center>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    vehicles,
    employee,
    permission,
    manifest,
    inventory,
    assignmentStats,
    resource,
  } = state;
  return {
    vehicles,
    employee,
    permission,
    manifest,
    inventory,
    assignmentStats,
    resource,
  };
}

const connectedYourCrew = connect(mapStateToProps)(YourCrewDetails);
export { connectedYourCrew as YourCrewDetails };

YourCrewDetails.propTypes = {
  vehicles: PropTypes.object.isRequired,
  employee: PropTypes.object.isRequired,
  permission: PropTypes.object.isRequired,
  inventory: PropTypes.object.isRequired,
  manifest: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  assignmentStats: PropTypes.object.isRequired,
  profile: PropTypes.func,
};
